import React, { useEffect, useLayoutEffect, useState, useRef, useContext } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, Input, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose, faCloudDownload, faEye, faTimes } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';
import DocumentFileView from "./Document"
import DocumentFormView from "./DocumentFormView"
import DocumentTab from "./FileEditing/DocumentTab";
import OcrView from "./Ocr"
import { navigationAction } from '../../../context/actions/navigationAction';
import { useDispatch, useSelector } from 'react-redux';
import './index.scss';
import PdfControls from '../../../components/common/PdfControls';
import { tagPanelAction } from '../../../context/actions/tagPanelAction';
import { getDefaultScale, addImageProcess, intersectRect, exportCSVFile, camelCase, isValEmpty, formatValue, pdfProcess } from "../../../utils/common";

import { maxScaleValue, pagination, scaleIncrement, toasterConfig } from "../../../utils/constants";
import LoaderUI from "../../../components/common/loader/index";
import { pdfDataSave, set_is_right_clicked, set_page_number, validateJsonData, saveValidateJsonData, processValidation, generateOutput, saveUnableToValidateJsonData, revelidateDocument, getFileByRevision, saveQAVerification, updateCompleteStatus, saveAsTriage } from "../../../context/actions/document";

import { unAssignDoc, resetReadOnlyDoc, getFile, getFilePage, getDocumentTypes, updateDocumentType, updateLabelType, rightsidebar, leftsidebarcicon, getDocuments, getDocumentsById, sendToLos, sendToIA, sendToHalcyon, sendToAnalyzer, updateDocumentIsCorrect } from "../../../context/actions/document";
import BackButton from "../../../components/common/BackButton";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VersionDropdown from './VersionDropdown';
import PdfPageDropdown from './PdfPageDropdown';
import { useHistory } from "react-router-dom";
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2';
import { Treebeard } from 'react-treebeard';
import * as filters from '../../../components/common/TreeBeard/filters';
import useComponentVisible from '../../../components/common/TreeBeard/useComponentVisible';
import decorators from "react-treebeard/dist/components/Decorators";
import defaultTheme from "react-treebeard/dist/themes/default";
import { tempAction, tagAction, validationAction, textAction, validationDataAction } from '../../../context/actions/tempAction';
import DocumentAccordion from './DocumentAccordion';
import { text } from '@fortawesome/fontawesome-svg-core';
import { SocketContext } from '../../../context/actions/socket';
import NoRecord from '../../../components/common/NoRecord';
import DocumentLog from './DocumentLog'
import { documentLogListing } from '../../../context/actions/document';
import _ from 'underscore';
import UnableToValidateModal from "./UnableToValidateModal";
import { scale } from 'pdf-lib';
import TimezoneClock from '../../../components/common/TimeZone';
import RevisionDropdown from './RevisionDropdown';
import jsonData from '../data.json';
import OriginalDocumentView from "./OriginalDocumentView";
import RulesIcon from "../../../assets/img/icons/updated-file.svg"

const pdfjsLib = require('pdfjs-dist');

toast.configure();
const MySwal = withReactContent(Swal);
// const PDFJS = window.pdfjsLib;
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.min.js';
// console.log(window.pdfjsLib.version);
const DocumentView = ({ filterSelectedFn,
	sortBySelectedFn, _handleTabChange, files, _handleSelected, _checkValiadation, _setCheckValiadation, _validationDataStatic, _validationErrorStatic, sidebarActivePacketIndex, select_Folder_id, deletedDisable, checkCTagChanges, checkVTagChanges, saveVData, saveCData, openedWindow, setOpenedWindow }) => {
	const {
		refrence,
		isComponentVisible,
		setIsComponentVisible
	} = useComponentVisible(true);
	const [activeTab, setActiveTab] = useState('1');
	const [activeSubTab, setActiveSubTab] = useState('1'); // State to manage active sub tab
	const checkAccept = useSelector((state) => state.tempReducer.accept)
	const checkFilledText = useSelector((state) => state.tempReducer.text)
	const checkTag = useSelector((state) => state.tempReducer.tag)
	const validationText = useSelector((state) => state.tempReducer.validationText)
	const navigationState = useSelector((state) => state.navigationReducer.isOn);
	const view = useSelector((state) => state.document.view)
	const latestVersion = useSelector((state) => state.document.latestVersion);
	console.log("button hitting", latestVersion)
	const selectedVersion = useSelector((state) => state.document.selectedVersion);
	console.log("selectedVersion", selectedVersion, latestVersion)
	const sellerLoanNumberOnPage = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.page);
	const is_multi_loan = useSelector((state) => state.document?.fileData?.is_multi_loan);
	let xmin = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.xmin);
	let xmax = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.xmax);
	const istagPanelVisible = useSelector((state) => state.tagPanelReducer.tagPanelVisible);
	let rightSide = useSelector((state) => state.document.isOn);
	const data = useSelector((state) => state.document.fileData);
	console.log('data jklhdaskljhadkjlhkjda ->', data)
	//const data = jsonData
	let blobBuffer = useSelector((state) => state.document.fileData?.pdfstreamToBuffer);
	const dispatch = useDispatch();
	const [pdf, setPdf] = useState();
	const [generateOutputPdf, setGenerateOutputPdf] = useState();
	const [pdfPagesCount, setPdfPagesCount] = useState(1);
	const [pageNumber, setPageNumber] = useState(1);
	const [page, setPage] = useState(pagination.page);
	const [paginations] = useState(pagination.limit);
	const [xmlTags, setXmlTags] = useState();
	const [xmlTagsOriginal, setXmlTagsOriginal] = useState();
	const [originalXmlTags, setOriginalXmlTags] = useState()
	const [reloadOcr, setReloadOcr] = useState(false);
	const [zoomOcr, setZoomOcr] = useState(false);
	const [zoomDoc, setZoomDoc] = useState(false);
	const [activeEditTabs, setActiveEditTabs] = useState('1');
	const [editTabsVal, setEditTabsVal] = useState();
	const [editTag, setEditTag] = useState();
	const [activeLink, setActiveLink] = useState(null);
	const [qaActiveLink, setQaActiveLink] = useState(data?.qc_status ? 1 : data?.qc_status === false ? 2 : 3);
	const [activeLinkDoc, setActiveLinkDoc] = useState(null);
	const [defaultScale, setDefaultScale] = useState(1);
	const [defaultScale1, setDefaultScale1] = useState(1);
	// const [defaultScaleDoc, setDefaultScaleDoc] = useState(getDefaultScale(window.innerWidth));
	const [defaultScaleDoc, setDefaultScaleDoc] = useState(1);
	const [loader, setLoader] = useState(false);
	const [versionLoader, setVersionLoader] = useState(false);
	const [disabledInputTagsText, setDisabledInputTagsText] = useState(latestVersion == selectedVersion || selectedVersion == undefined ? false : true);   //17 feb:  to disable input box on tags and tab when we come from autosaved file. undefined comes in case its original version

	console.log("selectedVersion", selectedVersion, latestVersion, disabledInputTagsText)

	const [createdUser, setCreatedUser] = useState(null);
	const [updatedAt, setUpdatedAt] = useState(null);
	const myRef = useRef(null);
	const [fieldPriority, setFieldPriority] = useState(false);
	const [priorityFlag, setPriorityFlag] = useState(false);
	const [disabledZoomFlag, setDisabledZoomFlag] = useState(false);
	const [disabledZoomFlagDoc, setDisabledZoomFlagDoc] = useState(false);
	const [noRecordFound, setNoRecordFound] = useState(true);
	const [activeEditTabsFlag, setActiveEditTabsFlag] = useState(false);
	const [scrollHeigh, setsScrollHeight] = useState({ x: null, y: null })
	const ref = React.createRef();;
	const [disabledZoomInButton, setDisabledZoomInButton] = useState(false);
	const [disabledZoomInButtonDoc, setDisabledZoomInButtonDoc] = useState(false);
	const [disabledZoomOutButton, setDisabledZoomOutButton] = useState(true);
	const [disabledZoomOutButtonDoc, setDisabledZoomOutButtonDoc] = useState(true);
	const [disabledSubmitButton, setDisabledSubmitButton] = useState(true);
	const [isTextInputEmpty, setIsTextInputEmpty] = useState(true);
	const [checkboxId, setCheckboxId] = useState([]);
	const [editInputBoxId, setEditInputBoxId] = useState([]);
	const [textId, setTextId] = useState([]);
	const [tagId, setTagId] = useState([]);
	const [editInputTagsId, setEditInputTagsId] = useState([]);
	const isAdminLoggedIn = useSelector(state => state?.user?.user?.isAdminLoggedIn)

	const selectedPage = useSelector((state) => state.document.page);
	const [currentVersion, setCurrentVersion] = useState(false);
	let jsonMetaDataDetailObject = useSelector((state) => state.document.jsonMeta);
	let jsonMetaDataDetail = useSelector((state) => state.document.jsonMeta[selectedPage]);
	let xmlMetaDetailObject = useSelector((state) => state.document.xmlMeta);
	let xmlMetaDetail = useSelector((state) => state.document.xmlMeta[selectedPage]);

	//console.log('xmlMetaDetail11111',xmlMetaDetail)


	const fileVersions = useSelector((state) => state.document.fileVersions || []);
	const revisions = useSelector((state) => state.document.revisions || []);
	const [uniId, setUniId] = useState();
	const [outSide, setOutSide] = useState(false);

	const [version, setVersion] = useState(latestVersion);
	const fileData = useSelector((state) => state.document.fileData);

	// console.log('read_only', fileData?.read_only)
	const [jsonMetaData, setJsonMetaData] = useState(jsonMetaDataDetail);
	const [xmlMeta, setXmlMeta] = useState(xmlMetaDetail);
	//const [xmlMetaTemp, setXmlMetaTemp] = useState(xmlMetaDetail)
	const [versionFlag, setVersionFlag] = useState(false);
	const history = useHistory();
	const [dropData, setDropData] = useState({ name: '', toggled: true, children: [] })
	const [dropdownData, setDropdownData] = useState({});
	const [cursor, setCursor] = useState(false);
	const [value, setValue] = useState('');
	const [checkText, setCheckText] = useState(2);
	const [isDocumentTypeSelected, setIsDocumentTypeSelected] = useState(false);
	const [ocrScale, setOcrScale] = useState();
	const [acceptedItms, setAcceptedItms] = useState(0);
	const [isPageChange, setIsPageChange] = useState(false)
	const folder = useSelector((state) => state.document.folder || null);
	let isRightClicked = useSelector((state) => state?.document?.isRightClicked);
	let valiadationData = useSelector((state) => state?.document?.validationJson);

	console.log('valiadationData --> 123', valiadationData)


	const [valiadationDetail, setValiadationDetail] = useState(valiadationData);
	let [sellerLoanNumber, setSellerLoanNumber] = useState('');
	let [isChangeSellerLoanNumber, setIsChangeSellerLoanNumber] = useState(false);
	const [addXmlTag, setAddXmlTag] = useState(null)
	const user = useSelector((state) => state.user.user)
	const [changeValidationData, setChangeValidationData] = useState(false)
	// const [changeTextTabValue, setChangeTextTabValue] = useState(false)
	const [changeInputValue, setChangeInputValue] = useState({});
	let [triggers, setTriggers] = useState(false)
	let [triggerFieldName, setTriggerFieldName] = useState('');
	const { backendSocket } = useContext(SocketContext);
	const [vTextChange, setVTextChange] = useState([]);
	const [cTextChange, setCTextChange] = useState([]);
	const [cTagsChange, setCTagsChange] = useState([]);
	const [vCheckChangeY, setVCheckChangeY] = useState([]);
	const [vCheckChangeN, setVCheckChangeN] = useState([]);
	const [cCheckChange, setCCheckChange] = useState([]);
	const [vErrorsChange, setVErrorsChange] = useState([]);
	let [outPutGeneratedAt, setOutPutGeneratedAt] = useState(null);
	let [outPutAnalyzerGeneratedAt, setOutPutAnalyzerGeneratedAt] = useState(null);


	let [outPutGeneratedAtIA, setOutPutGeneratedAtIA] = useState(null);
	let [outPutGeneratedAtHalcyon, setOutPutGeneratedAtHalcyon] = useState(null);
	let [isUnableToValidateOpen, setIsUnableToValidateOpen] = useState(false);
	const [docValidation, setDocValidation] = useState('');
	let [idleScale, setIdleScale] = useState(1)
	let xmlMetaDetailData = xmlMeta;
	const [invalidFields, setInvalidFields] = useState([]);
	let [disableUnableToUpdateButton, setDisableUnableToUpdateButton] = useState(false);
	let [disabledRevilidateButton, setDisabledRevilidateButton] = useState(false);
	let [unableToValidate, setUnableToValidate] = useState(false);
	let [disabledUnableToDocumentFields, setDisabledUnableToDocumentFields] = useState(false);
	const userDetail = useSelector((state) => state?.user?.user);
	const currentDocument = useSelector((state) => state.document.fileData);
	let docRecords = useSelector((state) => state.document.docRecords);
	let latestRevision = useSelector((state) => state.document.latestRevision);
	let [SentToIADisabled, setSentToIADisabled] = useState(false);
	let [SentToAnalyzerDisabled, setSentToAnalyzerDisabled] = useState(false);

	let [SentToHalcyonDisabled, setSentToHalcyonDisabled] = useState(false);
	let [unAssignDisable, setUnAssignDisable] = useState(false);
	const openTab = useSelector((state) => state?.document?.openedTab)
	let permissions = useSelector((state) => state.user.user.roles.permissions);
	const [tagValue, setTagValue] = useState(null);
	const [pageChanged, setPageChanged] = useState(false);

	let isQCPerson = permissions?.some((obj) => obj.SLUG === "quality_control");

	const [modalOpen, setModalOpen] = useState(false);
	const [triageModalOpen, setTriageModalOpen] = useState(fileData?.triage);
	const [failureReason, setFailureReason] = useState('');

	let calculateIdleScale = (pdfDim) => {
		let stripDim, ele = document.getElementById('getWidth')
		if (ele !== null) { // Check if the element with id 'getWidth' exists
			stripDim = ele.getBoundingClientRect();
			// let stripDim = document.getElementById('getWidth').getBoundingClientRect();
			// console.log("stripDim line 195", stripDim)
			let docTabWidth = document.getElementById('doc-tab');
			let sideBarWidth = 0
			if (docTabWidth) {
				sideBarWidth = docTabWidth.getBoundingClientRect().width
			}
			// console.log(stripDim.width,sideBarWidth, "checking doc-tab-width")
			let idleDimension
			if (sideBarWidth == 0) {

				idleDimension = stripDim.width - 100; // idleDimension is width of strip which is fixed and not horizontly scrollable
			}
			else {
				idleDimension = stripDim.width + sideBarWidth - 100
			}
			setDefaultScaleDoc(1);
			setIdleScale(1)
			let { width } = pdfDim;     // we are considering width of the file only for comparing actual file width and idle file width 
			let fileDimension = width

			// console.log('idleDimension', idleDimension, fileDimension)
			idleScale = 1
			if (fileDimension <= idleDimension) {  // increasing default scale of the file if width of the actual file is small
				for (let i = fileDimension; i < idleDimension; i = i + i * scaleIncrement) {
					console.log(i, idleScale, idleDimension, "nnn")
					setDefaultScaleDoc((p) => (p * fileDimension) < idleDimension ? p + scaleIncrement : p)
					idleScale = (idleScale * fileDimension) < idleDimension ? idleScale + scaleIncrement : idleScale
					setIdleScale((p) => (p * fileDimension) < idleDimension ? p + scaleIncrement : p)
					console.log(stripDim.width, sideBarWidth, idleScale, idleDimension, fileDimension, "checking doc-tab-width")


				}
				_refresh(true, idleScale)
			}
			else {  // decreasing default scale of the file if width of the actual file is large
				for (let i = fileDimension; i > idleDimension; i = i - i * scaleIncrement) {
					setDefaultScaleDoc((p) => (p * fileDimension) > idleDimension ? p - scaleIncrement : p)
					idleScale = (idleScale * fileDimension) > idleDimension ? idleScale - scaleIncrement : idleScale
					setIdleScale((p) => (p * fileDimension) > idleDimension ? p - scaleIncrement : p)


				}
				_refresh(true, idleScale)
			}
		}
	}

	useEffect(() => {
		checkCTagChanges(cTextChange, cTagsChange, cCheckChange)
	}, [cTextChange, cTagsChange, cCheckChange])

	useEffect(() => {
		checkVTagChanges(vTextChange, vCheckChangeN, vCheckChangeY)
	}, [vTextChange, vCheckChangeN, vCheckChangeY])

	const convertToLoanTerm = (input) => {
		let words = input.split(' ');
		let formatted = '';

		for (let i = 0; i < words.length; i++) {
			formatted += words[i].charAt(0).toUpperCase() + words[i].slice(1);
		}

		return formatted;
	}

	// const [value123, setValue123] = useState(valiadationDetail?.processedDocument?.results)

	const onDefaultScrollableState = () => {
		dispatch(set_is_right_clicked(false))
	}


	// const changeLog = (docId) => {
	// 	console.log('params of changeLog', docId)
	// 	dispatch(documentLogListing({ ...payload, limit: limit, page: page, docId: docId, fields: "user", populate: 'user' }))
	// }

	useEffect(() => {

		if (is_multi_loan) {
			setPageNumber(sellerLoanNumberOnPage);
		}
		return () => {
			dispatch(tempAction({})) //empty draft data if clicked else where
			dispatch(validationAction({}))
			dispatch(textAction(false))
			dispatch(tagAction(false))
			dispatch(validationDataAction(false))
			// if (backendSocket.id) {

			let data = { docId: fileData?._id, user: user?._id, socketId: backendSocket.id }
			// console.log('remove file is hitting from front-end ...', backendSocket.id, user?._id)
			backendSocket.emit('remove-file', data) //to remove entry from viewingfiles when user go away from the file
			// }
			// console.log('useEffect running')
		}
	}, [])

	// useEffect(() => {
	// 	if(backendSocket.id){
	// 		let data = { docId: fileData?._id, user: user?._id, socketId: backendSocket.id }
	// 		console.log('remove file is hitting from front-end ...', backendSocket.id)
	// 		backendSocket.emit('remove-file', data) //to remove entry from viewingfiles when user go away from the file
	// 	}
	// 	// console.log('useEffect running')
	// }, [backendSocket])

	const selectMoriOption = (val, index, previousValue, key) => {


		if (key == 'LoanNumber') {
			setSellerLoanNumber(previousValue ? previousValue : "");
			// setIsChangeSellerLoanNumber(true);
		}

		dispatch(validationDataAction(true))
		setValiadationDetail(prevState => ({
			...prevState,
			processedDocument: {
				...prevState.processedDocument,
				results: prevState.processedDocument.results.map((x, id) => {
					if (id == index) {
						x = {
							...x,
							morioption: val,
							index: null,
							value: previousValue
						};

					}
					return x;
				}),

			},

		}));



	}
	const changesValidationText = (val, index, key, type, index1, triggers) => {

		console.log('aaa', val, index, key, type, index1, triggers);
		// let val = (type == 'number' ? Number(e.target.value): type == 'DateTime' ? e.target.value: e)
		dispatch(validationDataAction(true))

		console.log('val of onchange fncn=>', val, 'key=>', key)

		if (type == 'number') {
			// console.log('value of onChange funciton', Number(val), 'val', val)
		}

		if (type == 'DateTime') {
			if (val) {
				console.log("first", val)
				val = `${moment(new Date(val)).format("yyyy-MM-DD")}T00:00:00`;
				console.log("Second", val)
			}
		}
		// let flag = false;
		// if (type == 'number' && isValEmpty(val)) {
		// 	flag = true
		// }
		if (key == 'LoanNumber') {
			setSellerLoanNumber(val);
			// setIsChangeSellerLoanNumber(true);
		}

		console.log('kasjdkasjdasdasd', valiadationData?.processedDocument?.results)

		setValiadationDetail(prevState => ({

			...prevState,

			processedDocument: {

				...prevState.processedDocument,

				results: prevState.processedDocument.results.map((x, id) => {

					if (id == index) {
						if (type == 'is_over_ride') {
							x = {
								...x,
								isOverride: val === true
							};
						}
						else {
							x = {
								...x,
								value: val
							}
						}


						// if (flag) {
						// 	delete (x.value)
						// }
						if (!isValEmpty(index1)) {
							x = {
								...x,
								morioption: true,
								index: index1
							};
						}
					}
					return x;
				}),

			},

		}));
		setTriggers(triggers);
		setTriggerFieldName(key)


	};

	const [timer, setTimer] = useState(new Date());

	useEffect(() => {
		setTimer(new Date());
	}, [])

	useEffect(() => {
		if (rightSide === "V") {
			setTimer(new Date());
		} else {
			setTimer(new Date())
		}
	}, [rightSide])

	// for changes in v tag

	const OnVTextChange = (value, key, check, id, index, type, errorIndex, errorTitle) => {

		// console.log("dasddfsdaqwew", check)
		// console.log('delete it rn', _validationDataStatic)

		// console.log('check of onVChange', check, 'key=>', key, 'value => ', value, 'id=>', id, 'index =>', index, 'type =>', type)

		let isChecked = false;
		let isErrorAccepted = false;
		let checkStatus = _validationErrorStatic && _validationErrorStatic[id] == true ? "(Unchecked)" : "(Checked)"
		if (index != undefined) value = `Code ${index}: ${errorTitle} ${checkStatus}`
		// if (index == 105) value = 'Document Validation'; // changes needed
		// if (index == 101) value = 'Field Validation';

		if (type == 'DateTime') {
			value = `${moment(new Date(value)).format("yyyy-MM-DD")}T00:00:00`;
		}

		if (_validationErrorStatic && _validationErrorStatic[id] == true) {
			isErrorAccepted = true;
		} else {
			isErrorAccepted = false;
		}
		// console.log('sadsadavfgre', _validationDataStatic);

		// console.log('validation statusss', _validationDataStatic[id], '=>', id, "apple");

		if (_validationDataStatic[id] === true) {
			isChecked = true;
		} else if (Array.isArray(_validationDataStatic[id])) {
			const subarray = _validationDataStatic[id];
			if (subarray[errorIndex] === true) {
				isChecked = true;
			} else {
				isChecked = false;
			}
		} else {
			isChecked = false;
		}

		if (isErrorAccepted == false && index) {
			if (check) {
				setVErrorsChange([...vErrorsChange, value])
			} else {
				setVErrorsChange(vErrorsChange.filter(item => item !== value))

			}
		}
		else if (isErrorAccepted == true && index) {
			if (check == false) {
				setVErrorsChange([...vErrorsChange, value])
			} else if (check == true) {
				setVErrorsChange(vErrorsChange.filter(item => item !== value))
			}
		}

		if (isChecked == false) {
			console.log('running tretre True', check)
			if (check && index == undefined) {
				setVCheckChangeY([...vCheckChangeY, key])
			} else if (check == false && index == undefined) {
				setVCheckChangeY(vCheckChangeY.filter(item => item !== key))
			}
		}
		else if (isChecked == true) {
			// console.log('running tretre False')
			if (check == false && index == undefined) {
				// console.log('running tretre False check false')
				setVCheckChangeN([...vCheckChangeN, key])
			} else if (check == true && index == undefined) {
				// console.log('running tretre False check true')
				setVCheckChangeN(vCheckChangeN.filter(item => item !== key))
			}
		}



		console.log('notepad 123', valiadationData?.processedDocument?.results)
		if (key == 'LoanNumber') {
			if (value == data?.loan_number) setIsChangeSellerLoanNumber(false);
			else setIsChangeSellerLoanNumber(true);
		}

		let isPresent = false;
		let hasChanged = false
		let oldValue, newValue;
		valiadationData?.processedDocument?.results?.length && valiadationData.processedDocument.results.map((item, key1) => {
			// console.log('final check 123 -->', item.value, value)
			if (item?.key == key) {
				oldValue = item.value
				if (value == item.value || (isValEmpty(item.value) && isValEmpty(value))) {
					hasChanged = false
					return;
				} else {
					newValue = value
					hasChanged = true
				}
			}
		});
		vTextChange.map(item => {
			if (item.key === key) {
				isPresent = true;
				return;
			}
		});

		// console.log('checking for isPresent and hasChanged', isPresent, hasChanged)

		if (hasChanged && check == undefined) {
			setVTextChange((prev) => {
				const index = prev.findIndex(item => item.key === key);
				if (index !== -1) {
					// Update existing entry
					return prev.map((item, i) =>
						i === index ? { key, oldValue, newValue } : item
					);
				} else {
					// Add new entry
					return [...prev, { key, oldValue, newValue }];
				}
			});
		}
		else if (isPresent && !hasChanged) {
			setVTextChange(vTextChange.filter(item => item.key !== key));
		}

	}

	useEffect(() => {
		console.log('vCheckChangeY updated:', vCheckChangeY);
	}, [vCheckChangeY]);

	useEffect(() => {
		console.log('vCheckChangeN updated:', vCheckChangeN);
	}, [vCheckChangeN]);

	// useEffect(() => {
	// 	console.log('vTextChange updated:', vTextChange);
	// }, [vTextChange]);

	// useEffect(() => {
	// 	console.log('vErrorsChange updated:', vErrorsChange);
	// }, [vErrorsChange]);

	// useEffect(() => {
	// 	console.log('vCheckChangeY updated:', cCheckChange);
	// }, [cCheckChange]);

	// useEffect(() => {
	// 	console.log('cTextChange updated:', cTextChange);
	// }, [cTextChange]);

	// useEffect(() => {
	// 	console.log('cTagsChange updated:', cTagsChange);
	// }, [cTagsChange]);

	// for changes in c text
	const OnCTextChange = (value, key, index, check) => {

		let oldValue;
		console.log('cheking value', value, 'index=>', index, 'key=>', key)



		// console.log('onCtextChange function running fine', index)

		let isPresent = false;
		let formattedTag = formatValue(key);
		let formattedTagObj = {};
		formattedTagObj[formattedTag] = index;

		// console.log('formattedTagObj', formattedTagObj)

		cTextChange.map(item => { // when entry is already present in this particular tag, remove it
			// console.log('item checking milton', item, 'formattedTagObj', formattedTagObj)
			if (JSON.stringify(item) == JSON.stringify(formattedTagObj)) {
				isPresent = true;
			}
		});
		// console.log('check for isPresent', isPresent)
		let hasChanged = false;

		xmlTags.map((item, key1) => {
			// console.log('checking for condn', item.tag, 'compare=>', key)
			if (item.tag == key) { // error
				// console.log('cTextChange e.target.value', key)
				// console.log('cTextChange present value', item.tag)
				item.overlap.map((item2, i) => {
					const fullIndex = key1 + ':' + i;
					// console.log('wednesday consoles testing overlap mapping', fullIndex, '=>', index)
					if (fullIndex == index) {
						// console.log('Atari item2.text original', item2.originalText, 'old =>', value)
						if (value == item2.originalText) {
							hasChanged = false;
							// console.log('running values matched 1')
							return;
						}
						else {
							oldValue = item2.originalText
							// console.log('running values matched')
							hasChanged = true;
						}
					}

				})
			}
		})

		formattedTagObj["oldValue"] = oldValue;
		formattedTagObj["newValue"] = value;
		if (check) {
			setCCheckChange((prev) => {
				const index = prev.findIndex(item => Object.keys(item)[0] === Object.keys(formattedTagObj)[0]);
				if (index !== -1) {
					// Update existing entry
					return prev.map((item, i) =>
						i === index ? formattedTagObj : item
					);
				} else {
					// Add new entry
					return [...prev, formattedTagObj];
				}
			});
		} else if (check == false) {
			setCCheckChange(cCheckChange.filter(item => JSON.stringify(item) !== JSON.stringify(formattedTagObj)))
		}

		// console.log('check for hasChanged and isPresent', hasChanged, '=>', isPresent)
		if (!isPresent && hasChanged && check == undefined) {
			console.log('cTextChange apple value is changing')
			setCTextChange((prev) => {
				const index = prev.findIndex(item => Object.keys(item)[0] === Object.keys(formattedTagObj)[0]);
				if (index !== -1) {
					// Update existing entry
					return prev.map((item, i) =>
						i === index ? formattedTagObj : item
					);
				} else {
					// Add new entry
					return [...prev, formattedTagObj];
				}
			});
		}
		else if (isPresent && !hasChanged) {
			console.log('cTextChange apple is getting cleared')
			setCTextChange(cTextChange.filter(item => JSON.stringify(item) != JSON.stringify(formattedTagObj)));
		}
	}

	useEffect(() => {
		console.log('cCheckChange updated:', cCheckChange, 'cTextChange =>', cTextChange);
	}, [cCheckChange, cTextChange]);

	const OnCTagsChange = (e, key, index) => {

		// const tempVar = xmlMetaDetailObject
		// const firstProperty = Object.keys(tempVar)[0]
		// const firstValue = tempVar[firstProperty].annotation.object;
		// const desiredValue = firstValue[index];
		// console.log('xmlMetaDetailObject', desiredValue);

		const desiredValue = xmlTagsOriginal[index].tag;
		const newDesiredValue = desiredValue.replace(/_/g, ' ').toLowerCase()


		// const desiredValue = savedTagArray[0];


		// key == item.tag
		let isPresent = false;
		let hasChanged = false;
		// console.log('running function 789') 
		let formattedKey = formatValue(key)
		let formattedDesiredValue = formatValue(newDesiredValue);
		let formattedETagName = formatValue(e.tagName)
		const jointValue = formattedDesiredValue + ':' + index;
		// let formattedTag = convertToLoanTerm(e.tagName)
		// let formattedTagObj = {};
		// formattedTagObj[formattedTag] = index;

		// console.log('index of c tag change',key)

		console.log('spacebound', formattedDesiredValue, 'key=>', formattedETagName, 'joint=>', jointValue);


		// console.log('activities checking onCtagChange values', formattedTag, "=>", formattedKey)

		console.log("tag changed 1234", e, key, index)

		cTagsChange.map(item => {
			if (item === jointValue) {
				isPresent = true;
				return;
			}
		});


		if (formattedETagName === formattedDesiredValue) {
			hasChanged = false;
		} else {
			hasChanged = true;
		}
		let updatedValue = { key: formattedDesiredValue, oldValue: formattedDesiredValue, newValue: formattedETagName }
		if (!isPresent && hasChanged) {
			// setCTagsChange([...cTagsChange, jointValue]);
			setCTagsChange([...cTagsChange, updatedValue]);

		} else if (isPresent && !hasChanged) {
			// setCTagsChange(cTagsChange.filter(item => item !== jointValue));
			setCTagsChange(cTagsChange.filter(item => JSON.stringify(item) != JSON.stringify(updatedValue)));
		}
	};

	useEffect(() => {
		console.log('cTagsChange updated:', cTagsChange);
	}, [cTagsChange]);


	useEffect(() => {
		if (triggers) {
			validateData(triggerFieldName);
			setTriggers(false)
			setTriggerFieldName('')
		}


	}, [triggers])


	useEffect(() => {
		if (validationText) {
			console.log("------->2", validationText)
			const lastItem = [...fileVersions].pop();
			let newversion;
			if (!lastItem) {
				newversion = 1
			} else {
				newversion = lastItem.version + 1;
			}
			dispatch(validationAction({
				json: valiadationDetail,
				organization: fileData?.organization,
				docId: fileData?._id,
				version: newversion,
				sellerLoanNumber: sellerLoanNumber,
				isChangeSellerLoanNumber: isChangeSellerLoanNumber
			}))
		}
		else {
			dispatch(validationAction({}))
		}


	}, [valiadationDetail])


	/// to put data in tempAction reducer that will trigger pdfSave api from private layout
	useEffect(() => {
		if (!disabledSubmitButton) {
			if (checkFilledText || checkTag) {
				const lastItem = [...fileVersions].pop();
				let newversion
				if (!lastItem) {
					newversion = 1
				} else {
					newversion = lastItem.version + 1;
				}
				dispatch(tempAction({
					...data, xmlMeta2: xmlMetaDetailObject,
					json2: jsonMetaDataDetailObject, pageNumber: pageNumber,
					current_version: false, version: newversion, folder_id: folder


				}))
			}
			else {
				dispatch(tempAction({}))
			}

		}
		else {
			dispatch(tempAction({}))
		}
	}, [disabledSubmitButton, xmlTags])



	// useEffect(() => {
	// 	// changeVersion(late)
	// 	// _refresh()
	// 	alert("hii")
	// 	getLatestVersion()
	// }, [activeTab])

	// let getLatestVersion = () => {
	// 	dispatch(
	// 		getFile({ docId: data._id, Au: null, version: latestVersion, pageNumber: pageNumber }, (response) => {

	// 			console.log(response, "checking latesty respo")
	// 			setValiadationDetail(response.validationJson)
	// 			setVersionFlag(true);
	// 			// setVersionLoader(false);
	// 			setChangeInputValue({})  //24 feb
	// 			setCheckText(0)
	// 			setCheckboxId([])
	// 			setEditInputTagsId([])
	// 			setEditInputBoxId([])
	// 			setDisabledSubmitButton(true);

	// 			if (response) {
	// 				setVersion(response.version);
	// 				setCurrentVersion(response.version)
	// 				setAcceptedItms(0);
	// 				setVersionLoader(false);
	// 				// callBack(true)

	// 			}
	// 		})
	// 	);
	// }

	/**
	 * 
	 * 
	* @description func for calculateing scale
	* @param {*} itam coordinatess
	* @returns number
	*/
	const scaleCal = (item) => (Number(item) / Number(ocrScale))
	/**
	 * @description Function calculating bounds height and width
	 * @param {Number} value accepting number value
	 * @returns return number value
	 */
	const calc = (value) => (value < 0 ? value * -1 : value);


	/**
	* @description function call to check overlapping rectange json bounds 
	* @param {*} xmlTg XML bounds data
	* @returns retun array which is overlapping
	*/
	const boundsIsOverlapDownload = async (xmlTg, jsondata) => {
		let intesr = []


		jsondata.analyzeResult.readResults[0].lines.map((val) =>
			val.words.map(async (word) => {
				let xco = {
					x: Number(word.boundingBox[0]), // scaleJsonCal function use to set zoom in/out coordinates
					y: Number(word.boundingBox[1]),
					w: (calc(Number(word.boundingBox[2]) - Number(word.boundingBox[0]))),
					h: (calc(Number(word.boundingBox[1]) - Number(word.boundingBox[7]))),
					text: word.text,
					isAccepted: word?.isAccepted,
					confidence: word.confidence,
					updatedAt: word?.updatedAt || false // set if any tags/text values updating to maintain logs
				}

				let inter = intersectRect(xmlTg.bounds, xco)
				if (intersectRect(xmlTg.bounds, xco)) { //identify intesect rectange xml/ json

					xco = { ...xco, id: `${word.boundingBox[0]}:${word.boundingBox[1]}` }


					intesr.push(xco)
				}
			})
		)
		return intesr
	}



	/**
	* @description method call to set bounds with scale for XML eveluate 
	* @param {*} bouns rectange 
	* @returns 
	*/
	const eveluateXMLBounds = async (bouns) => {
		let bounds = {
			x: Number(bouns.xmin._text),
			y: Number(bouns.ymin._text),
			w: (Number(bouns.xmax._text) - Number(bouns.xmin._text)),
			h: (Number(bouns.ymax._text) - Number(bouns.ymin._text))
		}
		return bounds
	}

	/**
	* @description function get xml file data and eveluate 
	*/

	const eveluateXML = async (xmlMetaRe, jsondata) => {
		let xmlTagsEveluted = [];
		for (var i = 0; i < xmlMetaRe?.annotation.object.length; i++) {
			let newObj = {
				id: `${xmlMetaRe?.annotation.object[i].name._text}:${i}`, // this id use to maintain while fouse on any files hilight bounds on same index
				updatedAt: xmlMetaRe?.annotation.object[i]?.updatedAt || false,
				//tag: xmlMetaRe?.annotation.object[i].name._text,
				tag: xmlMetaRe?.annotation.object[i].updatedName?._text ? xmlMetaRe?.annotation.object[i].updatedName?._text : xmlMetaRe?.annotation.object[i].name._text,
				bounds: await eveluateXMLBounds(xmlMetaRe?.annotation.object[i].bndbox)// evaluate height,width, xmin and ymin coordinates
			}
			newObj.overlap = await boundsIsOverlapDownload(newObj, jsondata);// compare overlap bounds with json 
			xmlTagsEveluted.push(newObj);
		}

		return xmlTagsEveluted
	}
	/****Get json Data for  CSV Download*/
	const getJsonData = (jsonArray) => {
		let csvJsonArray = []
		for (var i = 0; i < jsonArray.length; i++) {
			var key = jsonArray[i].id
			var keyData = key.split(":")
			let newObj
			if (jsonArray && jsonArray[i].overlap && jsonArray[i].overlap[0] && jsonArray[i].overlap[0].text) {
				newObj = {
					id: jsonArray[i].id,
					value: jsonArray && jsonArray[i].overlap && jsonArray[i].overlap[0] && jsonArray[i].overlap[0].text// evaluate height,width, xmin and ymin coordinates
				}
			} else {
				newObj = {
					id: jsonArray[i].id,
					value: '022'// evaluate height,width, xmin and ymin coordinates
				}
			}

			csvJsonArray.push(newObj);
		}

		return csvJsonArray

	}


	/***Get json object */

	const getJsonObjectData = (jsonArray) => {
		let csvJsonObject = {}

		for (var i = 0; i < jsonArray.length; i++) {
			var key = jsonArray[i].id
			var keyData = key.split(":")
			var keyValue = keyData[0]
			csvJsonObject[keyValue.trim()] = keyValue.trim()


		}


		return csvJsonObject

	}

	/***Download content on csv format */
	const downLoadCsv = () => {
		const lastItem = [...fileVersions].pop();
		setLoader(true)
		dispatch(
			getFile({ docId: data._id, Au: null, version: lastItem && lastItem.version, pageNumber: pageNumber }, async (response) => {


				let jsonsMeta = response && response.json
				let xmlsMeta = response && response.xml
				let xmlEvwluteResult = await eveluateXML(xmlsMeta, jsonsMeta)
				let jsonArrayData = await getJsonData(xmlEvwluteResult)
				let jsonObjectData = await getJsonObjectData(jsonArrayData)

				var itemsFormatted = [];
				jsonArrayData && jsonArrayData.length > 0 && jsonArrayData.map((item, index) => {
					itemsFormatted.push({
						[item.id]: item.value
					});
				});
				let formAteItem = []
				//let object = itemsFormatted.reduce((prev, curr) => ({ ...prev, ...curr }), {});
				var objects = itemsFormatted.reduce(
					(obj, item) => Object.assign(obj, { [item.id]: item.value }), {});

				let objValu = {}
				for (var i = 0; i < jsonArrayData.length; i++) {
					let values = jsonArrayData[i].value
					let keys = jsonArrayData[i].id
					var keyData = keys.split("-")
					objValu[keyData[0]] = values.replace(/,/g, '')

				}
				formAteItem.push(objValu)
				var fileTitle = fileData?.name; // or 'my-unique-title'	
				let exportCsv = await exportCSVFile(jsonObjectData, formAteItem, fileTitle);
				setLoader(false)
			})
		);


	}

	const onToggle = (node, toggled) => {
		setIsComponentVisible(true)
		if (!node.children) {
			let selectOptionPrevs = value;
			setValue(node.name)
			MySwal.fire({
				title: 'Are you sure?',
				text: "You want to update document type",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, update it!'
			}).then((result) => {
				if (result.isConfirmed) {
					dispatch(updateLabelType({ id: fileData._id, type: node._id }, (res) => {
						if (res) {
							filterSelectedFn(null)
							sortBySelectedFn(null)
							setIsDocumentTypeSelected(true);
							let docs = [...docRecords]
							var index = docs.findIndex(doc => doc._id == fileData?._id);
							docs[index].unable_to_validate = res?.unable_to_validate;
							docs[index].sentToLos = res?.sentToLos;
							docs[index].sentToHalcyon = res?.sentToHalcyon;
							docs[index].sentToIA = res?.sentToIA;
							docs[index].sentToAnalyzer = res?.sentToAnalyzer;
							docs[index].complete = res?.complete;
							docs[index].type = res?.type;
							docs[index].packet_type = res?.packet_type;
							dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs })
							if (!res.packet_type) {
								closeRightSideBar()
							}
							changeVersion(0, 'resetToOriginal');

						}
					}))
				} else if (result.isDismissed) {
					if (selectOptionPrevs) {
						setValue(selectOptionPrevs);
					} else {
						setValue('')
						setIsComponentVisible(false)
					}

				}

			})
		}
		if (cursor) {
			cursor.active = false;
		}
		node.active = true;
		if (!node.name) {
			node.toggled = true;
		}
		else if (node.children) {
			node.toggled = toggled;
		}
		setCursor(node);
		setDropdownData(Object.assign({}, dropdownData))
	}


	const onFilterMouseUp = ({ target: { value } }) => {
		const filter = value.trim();
		if (!filter) {
			return setDropdownData(dropData);
		}
		let filtered = filters.filterTree(dropData, filter);
		filtered = filters.expandFilteredNodes(filtered, filter);

		setDropdownData(filtered);
	}
	// get all document types
	useEffect(() => {
		// dispatch(rightsidebar('D'));  //16 feb commented due to problem arising in draft functionality as it dosent open side bar when we come from draft lists
		dispatch(leftsidebarcicon(0));
		_getDocumentTypes()
		onDefaultScrollableState()

	}, []);


	// get all document types
	/*useEffect(() => {
		setValiadationDetail(prevState => ({...prevState,valiadationData}))
	}, [valiadationData]);*/



	/**
	  * @description method call to get all documet types
	  */
	const _getDocumentTypes = async () => {
		if (fileData?.type) {
			setIsDocumentTypeSelected(true)
		}
		dispatch(getDocumentTypes({ limit: pagination.maxlimit, deleted: true }, (res) => {
			let newdata = { ...dropData, children: res?.tree };
			setDropData(newdata);
			let selectedDoc = res?.result?.docs.find((item) => {
				if (item._id === fileData?.type) {
					return item;
				}
			});
			setValue(selectedDoc?.name)
		}))
	}

	const navigationHandler = () => {
		dispatch(navigationAction(!navigationState));
	}
	const tagPanelHandler = () => {
		dispatch(tagPanelAction(!istagPanelVisible));
	}
	const tagPanelOverlayHandler = () => {
		dispatch(tagPanelAction(false));
	}
	const overClickHandler = () => {
		dispatch(navigationAction(false));
	}
	const _changeTabTags = (val) => {
		if (val !== activeEditTabs) {
			setDisabledZoomFlag(true)
		}

		setActiveEditTabsFlag(true)
		setActiveEditTabs(val)
	}
	const toggle = tab => {
		//setLoader(true)

		setActiveTab(tab);
		//setLoader(false)
		//if (activeTab !== tab) setActiveTab(tab);
		//if (activeTab !== 2) _handleTabChange(true)
	}
	const toggleSubTab = (tab) => {
		if (activeSubTab !== tab) setActiveSubTab(tab);
	}

	/**
	 * @description function trigger when click on reload/reset ocr view 
	 * @param {*} tab boolean
	 */
	// const _refresh = (tab = true) => {
	// 	setActiveLink(null);
	// 	setEditTabsVal()
	// 	setZoomOcr(getDefaultScale(window.innerWidth))
	// 	setDefaultScale(getDefaultScale(window.innerWidth));
	// 	setFieldPriority(false)
	// 	setReloadOcr(tab);
	// 	setPriorityFlag(false);
	// 	setDisabledZoomOutButton(true);
	// 	setDisabledZoomInButton(false);
	// 	if (myRef.current)
	// 		myRef.current.scrollTo(0, 0);
	// };


	const _refresh = (tab = true, tempIdleScale = 1) => {
		setEditTabsVal()
		if (activeTab === '1') {
			// setDefaultScale(getDefaultScale(window.innerWidth));
			console.log(idleScale, "sss this is _refresh function")
			// setDefaultScale(1);
			setDefaultScale(idleScale == 1 ? tempIdleScale : idleScale);
			setDefaultScale1(idleScale == 1 ? tempIdleScale : idleScale);
			setIdleScale(idleScale == 1 ? tempIdleScale : idleScale)
			setActiveLink(null);
			// setZoomOcr(getDefaultScale(window.innerWidth))
			// setZoomOcr(getDefaultScale(window.innerWidth))
			// setZoomOcr(1)
			setZoomOcr(idleScale)
			setDisabledZoomOutButton(true);
			setDisabledZoomInButton(false);
		}
		if (activeTab === '2') {
			// setDefaultScaleDoc(getDefaultScale(window.innerWidth));
			// setDefaultScaleDoc(1);
			setDefaultScaleDoc(idleScale);
			setActiveLinkDoc(null);
			// setZoomDoc(getDefaultScale(window.innerWidth))
			// setZoomDoc(1)
			setZoomDoc(idleScale)
			setDisabledZoomOutButtonDoc(true);
			setDisabledZoomInButtonDoc(false);
		}


		setFieldPriority(false)
		setReloadOcr(tab);
		setPriorityFlag(false);

		if (myRef.current)
			myRef.current.scrollTo(0, 0);
	};

	const _showReview = (tab) => {
		setFieldPriority(tab);
		setActiveLink(tab);
		setPriorityFlag(true);
		setNoRecordFound(true);

	};

	const toggleModal = () => {
		setModalOpen(!modalOpen);
	};

	const toggleTriageModal = () => {
		setTriageModalOpen(!triageModalOpen);
	};

	const qaStatus = (tab) => {
		setQaActiveLink(tab)
		toggleModal();

		// if (tab == 2) {
		// }
		// if(tab == 1){
		// 	QAVerification(true)
		// }
	};

	const QAVerification = (status, message) => {
		if (status == true) {
			dispatch(saveQAVerification({ status: true, docId: data?._id, version: data?.version, validationCompletionTime: Math.round((new Date() - timer) / 1000) }, (res) => {
				console.log("dsdasdasd")
				setTimer(new Date())
			}))
		} else if (status == false) {
			dispatch(saveQAVerification({ status: false, reason: message, docId: data?._id, version: data?.version, validationCompletionTime: Math.round((new Date() - timer) / 1000) }, (res) => {
				setTimer(new Date())
			}))
		}
	}

	const handleInputChange = (event) => {
		setFailureReason(event.target.value);
	};

	const handleSubmit = () => {
		if (qaActiveLink == 1) {
			QAVerification(true);
			toggleModal();
		} else {
			if (failureReason == "" || failureReason == null) {
				toast.error('Enter a valid reason.', toasterConfig);
			} else {
				QAVerification(false, failureReason);
				toggleModal();
			}
		}
	};



	/**f
	 * @description function trigger when click on zoom in(+) ocr view 
	 * @param {*} val scale value
	 */
	// const _zoomInOcr = (val) => {
	// 	setDisabledZoomOutButton(false);
	// 	setActiveLink(val);
	// 	let scal = parseFloat(defaultScale + 1);
	// 	if (scal <= maxScaleValue) {
	// 		setDisabledZoomFlag(true);
	// 		setDefaultScale(parseFloat(scal));
	// 		setZoomOcr(parseFloat(scal))
	// 		if (parseFloat(scal + 1) >= maxScaleValue) {
	// 			setDisabledZoomInButton(true);
	// 			setActiveLink(null)
	// 		}
	// 	}

	// }
	const _zoomInOcr = (val) => {
		if (activeTab === '1') {
			setDisabledZoomOutButton(false);
			setActiveLink(val);
		}
		if (activeTab === '2') {
			setDisabledZoomOutButtonDoc(false);
			setActiveLinkDoc(val);
		}

		let scal = parseFloat(defaultScale + scaleIncrement);
		// let scaleDiff = 0;
		// if (idleScale > defaultScaleDoc) {
		// 	scaleDiff = idleScale - defaultScaleDoc
		// }
		let scalDoc = parseFloat(defaultScaleDoc + scaleIncrement);
		if (scal <= maxScaleValue || scalDoc <= maxScaleValue) {

			if (activeTab === '1') {

				setDefaultScale(parseFloat(scal));
				setDefaultScale1(parseFloat(scal));
				// setDisabledZoomFlag(true);
				setZoomOcr(parseFloat(scal))
			}
			if (activeTab === '2') {
				setDefaultScaleDoc(parseFloat(scalDoc));
				setZoomDoc(parseFloat(scalDoc))
				// setDisabledZoomFlagDoc(true);
			}

			if (parseFloat(scal + 1) >= maxScaleValue) {
				setDisabledZoomInButton(true);
				// setDisabledZoomInButtonDoc(true);
				setActiveLink(null)
			}
			if (parseFloat(scalDoc + 1) >= maxScaleValue) {
				// setDisabledZoomInButton(true);
				setDisabledZoomInButtonDoc(true);
				setActiveLink(null)
			}
		}



	}
	/**
	 * @description function trigger when click on zoom out(-) ocr view 
	 * @param {*} val scale value
	 */
	const _zoomOutOcr = (val) => {

		if (activeTab === '1') {
			setActiveLink(val);
			setDisabledZoomInButton(false);
		}
		if (activeTab === '2') {
			setActiveLinkDoc(val);
			setDisabledZoomInButtonDoc(false);
		}

		// let scal = Number(parseFloat(defaultScale - 1).toFixed(1));
		// let scalDoc = Number(parseFloat(defaultScaleDoc - 0.25).toFixed(1));
		let scal = Number(parseFloat(defaultScale - scaleIncrement))
		let scalDoc = Number(parseFloat(defaultScaleDoc - scaleIncrement));
		console.log(defaultScaleDoc, scalDoc, "scalDocscalDocscalDoc")
		// if (scal >= getDefaultScale(window.innerWidth) || scalDoc >= getDefaultScale(window.innerWidth)) {

		if (defaultScale >= scal || defaultScaleDoc >= scalDoc) {
			if (activeTab === '1') {
				setDisabledZoomFlag(true);
				setDefaultScale(parseFloat(scal));
				setDefaultScale1(parseFloat(scal));
				setZoomOcr(parseFloat(scal))
			}
			if (activeTab === '2') {
				// setDisabledZoomFlagDoc(true);
				setDefaultScaleDoc(parseFloat(scalDoc));
				setZoomDoc(parseFloat(scalDoc))
			}
			console.log(scalDoc, defaultScaleDoc, idleScale, "defaultScaleDoc 00000000000000000000")
			// if (parseFloat(scal) === parseFloat(getDefaultScale(window.innerWidth)) || parseFloat(scalDoc) === parseFloat(getDefaultScale(window.innerWidth))) {
			if (Number(scal) <= idleScale || Number(scalDoc) <= idleScale) {
				console.log(scalDoc, defaultScaleDoc, idleScale, "defaultScaleDoc 11111111111111111")
				if (activeTab === '1' && Number(scal) <= idleScale) {

					setDisabledZoomOutButton(true);
					setDisabledZoomInButton(false)
					setActiveLink(null);
				}
				if (activeTab === '2' && Number(scalDoc) <= idleScale) {
					console.log(scalDoc, defaultScaleDoc, idleScale, "defaultScaleDoc 2222222222222222222")
					setDisabledZoomOutButtonDoc(true);
					setActiveLinkDoc(null);
				}

			}
		}

	}
	// Scroll the canvas to the selected text
	useLayoutEffect(() => {
		if (myRef && myRef.current != null && scrollHeigh) {
			myRef.current.scrollTo(scrollHeigh.x, scrollHeigh.y)
		}
	}, [scrollHeigh])

	const backClick = () => {
		// if(currentDocument?.reading_by === userDetail?._id && currentDocument.read_only){
		// 	dispatch(resetReadOnlyDoc({ docId: currentDocument._id}, (result) => {
		// 		if(result){
		// 			backendSocket.emit('check-doc-status',currentDocument)
		// 			console.log(currentDocument._id," doc reset")
		// 		}
		// 	}))
		// }
		history.push("/documents", { activeLoan: sidebarActivePacketIndex, _select_Folder_id: select_Folder_id });
	}

	/**
	 * @description function trigger when changes xml tags in ocr view 
	 * @param {*} val tag value
	 */
	const changesXmlTags = (val, pos, currentPage, changesViaVersion, tag_Id, tag) => {

		let tag_position = tag_Id.split(":")[0];
		dispatch(tagAction(true))

		let id = pos + ':' + currentPage;

		let tagIds = []

		dispatch(tagAction(true))

		if (tagId.findIndex((cur) => cur === id) == -1) {
			tagIds = [...tagId, id]
			setTagId(p => p = [...tagIds])
		}

		const lastItem = [...fileVersions].pop();
		if (disabledInputTagsText)
			return;

		let newversion;
		if (!lastItem) {
			newversion = 1
		} else {
			newversion = lastItem.version + 1;
		}
		//setDisabledSubmitButton(false)   //28 feb: commented because save button was enabling for a fraction of second if a field of text is empty and we change tags	
		if (!Object.keys(changeInputValue).length) {
			setDisabledSubmitButton(false)
		}

		if (!changesViaVersion) {

			if (val) {
				if (editInputTagsId.findIndex((cur) => cur === id) == -1) {

					setEditInputTagsId((prev) =>
						[...prev, id]
					);
				}

			} else {

				let i = editInputBoxId.findIndex((cur) => cur === id)
				editInputTagsId.splice(i, 1)
				setEditInputTagsId((prev) =>
					prev = editInputTagsId
				);
			}
		}

		// let isValueAllreadyChanged = xmlMetaDetail.annotation.object.find((value, i) => {

		// 	if (i == tag_position) {
		// 		console.log('iisValueAllreadyChanged', value)
		// 		if (value.updatedAt) {
		// 			return true
		// 		} else {
		// 			return false
		// 		}
		// 	}

		// })
		// console.log('isValueAllreadyChanged 123', isValueAllreadyChanged) delete this comment

		let xmlTagsList = xmlMetaDetailData.annotation.object.map((item, index) => {

			// console.log('thusday checking consoles', item)
			//	if (index === pos) {
			if (index == tag_position) {
				// console.log('front-end', isValueAllreadyChanged, item)
				// console.log('Sdd hunters', item.savedName);
				// const flag123 = false;
				// console.log('clutch testing', tag.updatedAt)
				// console.log('item.updatedAt 1', item.updatedAt)
				// console.log('monday testing results', item.name?._text.replace(/_/g, ' '), val)
				item.updatedName = {};
				//item.savedName?.replace(/_/g, ' ').trim() == val.trim()
				item.updatedName._text = val.toLowerCase().replace(/ /g, "_")
				item.updatedAt = new Date() // updated value in json file
				// console.log('clutch checking type', item.savedName._text, typeof(item.savedName._text))
				// if (tag.updatedAt == false && item.savedName ? (item.savedName._text.replace(/_/g, ' ').trim() == val.trim())
				// 	: (item.name?._text.replace(/_/g, ' ').trim() == val.trim())) {
				if ((tag.updatedAt == false && item.name?._text.replace(/_/g, ' ').trim() == val.trim())) {
					// console.log('clutch test true')
					delete item.updatedAt;
				}
				console.log('clutch test apple', item?.savedName?._text.replace(/_/g, ' ').trim(), 'or=>', item?.name?._text.replace(/_/g, ' ').trim(), '=>', val.trim(), '=>123', tag.updatedAt)
				// console.log('item.updatedAt 2', item.updatedAt)

				item.changesViaVersion = newversion;
			}
			if (!item.name._text.trim()) {

				setDisabledSubmitButton(true);

			}
			return item;
		});

		let xmlTagsListt = xmlTags.map((item, index) => {
			//if (index === pos) {
			if (index == tag_position) {
				item.tag = val;
			}
			return item;
		});

		xmlMeta.annotation.object = xmlTagsList;
		setXmlTags(xmlTagsListt);
		// setOriginalXmlTags(xmlTagsListt)
		setXmlMeta(xmlMeta);

	}

	/**
	 * @description function trigger when changes xml tags in ocr view 
	 * @param {*} val tag value
	 */
	const changesXmlText_v1 = (value, index, pos) => {

		const lastItem = [...fileVersions].pop();
		if (disabledInputTagsText)
			return;
		setDisabledSubmitButton(false);
		setIsTextInputEmpty(false)
		setCheckText(1)
		const axisArray = editTabsVal.split("-");
		const jsonMetaDataDetailData = jsonMetaData;
		const jsonMetadataArray = jsonMetaDataDetail.analyzeResult.readResults[0].lines.map((val) => (
			{
				...val, words: val.words.map((word) => {
					if (word.boundingBox[0] == axisArray[0] && word.boundingBox[1] == axisArray[1]) {
						word.text = value
						word.updatedAt = new Date() // updated value in json file
					}
					if (!word.text.trim()) {
						setDisabledSubmitButton(true);
						setIsTextInputEmpty(false)
					}
					return word;
				})
			}
		))
		jsonMetaDataDetailData.analyzeResult.readResults[0].lines = jsonMetadataArray;
		setJsonMetaData(jsonMetaDataDetailData);
		let xmlTagsList = xmlTags.map((item, i) => {
			if (i === index) {
				item.overlap[pos].text = value;
			}
			return item;
		});
		setXmlTags(xmlTagsList);

	}

	//to disable save button if a text field is left empty , checkbox checked and unchecked conditions.    
	const disableSaveButton = () => {
		let keys = Object.keys(changeInputValue).filter(key => changeInputValue[key] === '');
		let keysWithValue = Object.keys(changeInputValue).filter(key => changeInputValue[key] !== '');
		if (keys.length) {

			setDisabledSubmitButton(true)
		}
		else if (!acceptedItms && !keysWithValue.length && !checkTag) {
			setDisabledSubmitButton(true)
		}
		else {
			setDisabledSubmitButton(false)
		}
	}

	useEffect(() => {
		disableSaveButton()
	}, [xmlTags])
	/**
	 * @description function trigger when changes xml tags in ocr view 
	 * @param {*} val tag value
	 */
	const changesXmlText = (value, index, pos, id, item) => {
		// setChangeTextTabValue(true)
		// let tagIds = []
		// 	if (tagId.findIndex((cur) => cur === id) == -1) {
		// 		tagIds = [...tagId, id]
		// 		setTagId(p => p = [...tagIds])
		// 	}

		setChangeInputValue({ ...changeInputValue, [id]: value })
		dispatch(textAction(true))
		let textIds = [...textId, id];

		if (textId.findIndex((cur) => cur === id) == -1) {
			setTextId((prev) => prev = [...textIds]
			);
		}
		const lastItem = [...fileVersions].pop();
		const axisArray = editTabsVal?.split(":");
		const jsonMetaDataDetailData = jsonMetaData;

		if (!jsonMetaDataDetailData?.changesViaVersion) {
			if (editInputBoxId.findIndex((cur) => cur === id) == -1) {
				setEditInputBoxId((prev) =>
					[...prev, id]
				);
			}
			// if (value) {
			// 	console.log('111111111111111111');
			// 	if (editInputBoxId.findIndex((cur) => cur === id) == -1) {
			// 		console.log('2222222222222222');
			// 		setEditInputBoxId((prev) =>
			// 			[...prev, id]
			// 		);

			// 	}
			// } else {
			// 	console.log('333333333333');
			// 	let i = editInputBoxId.findIndex((cur) => cur === id)
			// 	editInputBoxId.splice(i, 1)
			// 	setEditInputBoxId((prev) =>
			// 		prev = editInputBoxId
			// 	);


			// }
		} else if (jsonMetaDataDetailData?.changesViaVersion && !jsonMetaDataDetailData?.changesViaVersion[axisArray[0] + ':' + axisArray[1]]) {
			if (editInputBoxId.findIndex((cur) => cur === id) == -1) {
				setEditInputBoxId((prev) =>
					[...prev, id]
				);
			}

			// if (value) {
			// 	console.log('44444444444444444');
			// 	if (editInputBoxId.findIndex((cur) => cur === id) == -1) {
			// 		setEditInputBoxId((prev) =>
			// 			[...prev, id]
			// 		);
			// 	}

			// } else {
			// 	console.log('555555555');
			// 	// let i = editInputBoxId.findIndex((cur) => cur === id)
			// 	// editInputBoxId.splice(i, 1)
			// 	// setEditInputBoxId((prev) =>
			// 	// 	prev = editInputBoxId
			// 	// );
			// 	setEditInputBoxId((prev) =>
			// 		[...prev, id]
			// 	);

			// }

		}


		if (disabledInputTagsText)
			return;
		let newversion;
		if (!lastItem) {
			newversion = 1
		} else {
			newversion = lastItem.version + 1;
		}
		setDisabledSubmitButton(false);
		setIsTextInputEmpty(false)
		setCheckText(1)


		if (!jsonMetaDataDetailData.updatedAt) {
			jsonMetaDataDetailData.updatedAt = {};

		}
		if (!jsonMetaDataDetailData.changesViaVersion) {
			jsonMetaDataDetailData.changesViaVersion = {};

		}
		//console.log('axisArray==', axisArray);
		for (var i = 0; i < jsonMetaDataDetailData?.text.length; i++) {
			if (jsonMetaDataDetailData.left[i] == axisArray[0] && jsonMetaDataDetailData.top[i] == axisArray[1]) {
				//console.log('if check left[i] top[i]', jsonMetaDataDetailData.left[i], jsonMetaDataDetailData.top[i]);
				jsonMetaDataDetailData.text[i] = value
				jsonMetaDataDetailData.updatedAt[axisArray[0] + ':' + axisArray[1]] = new Date()
				jsonMetaDataDetailData.changesViaVersion[axisArray[0] + ':' + axisArray[1]] = newversion;

				// console.log('wednesday client testing results apple', item)

				if (item?.updatedAt == false && value == item.originalText) {
					jsonMetaDataDetailData.updatedAt[axisArray[0] + ':' + axisArray[1]] = null;
					// delete jsonMetaDataDetailData.changesViaVersion[axisArray[0] + '-' + axisArray[1]]
				}
			}
			else {
				//console.log('else check left[i] top[i] ', jsonMetaDataDetailData.left[i], jsonMetaDataDetailData.top[i], jsonMetaDataDetailData.text[i]);
			}

			if (!jsonMetaDataDetailData.text[i].trim()) {

				setDisabledSubmitButton(true);
				setIsTextInputEmpty(false)
			}

		}
		setJsonMetaData(jsonMetaDataDetailData);
		let xmlTagsList = xmlTags.map((item1, i) => {
			if (i === index) {
				item1.overlap[pos].text = value;
			}
			return item1;
		});
		setXmlTags(xmlTagsList);

	}

	const acceptXmlText = (value, index, pos, id) => {

		const lastItem = [...fileVersions].pop();
		let newversion;
		if (!lastItem) {
			newversion = 1
		} else {
			newversion = lastItem.version + 1;
		}
		const axisArray = id.split(":");
		if (value) {
			//dispatch({ type: "SET_ACCEPT", data: true })
			if (checkboxId.findIndex((cur) => cur === id) == -1) {
				setCheckboxId((prev) =>
					[...prev, id]
				);
			}

		} else {

			let i = checkboxId.findIndex((cur) => cur === id)
			checkboxId.splice(i, 1)
			setCheckboxId((prev) =>
				prev = checkboxId
			);
		}




		// setCheckboxId((prev) =>
		// 	checkboxId.includes(id)
		// 		? prev.filter((cur) => cur !== id)
		// 		: [...prev, id])

		setIsTextInputEmpty(false)
		setCheckText(1)

		const jsonMetaDataDetailData = jsonMetaData;
		if (!jsonMetaDataDetailData.acceptedAt) {

			jsonMetaDataDetailData.acceptedAt = {};
			jsonMetaDataDetailData.isAccepted = {};
		}

		if (!jsonMetaDataDetailData.changesViaVersion) {
			jsonMetaDataDetailData.changesViaVersion = {};

		}

		for (var i = 0; i < jsonMetaDataDetailData?.text.length; i++) {
			if (jsonMetaDataDetailData.left[i] == axisArray[0] && jsonMetaDataDetailData.top[i] == axisArray[1]) {

				if (value) {
					jsonMetaDataDetailData.isAccepted[axisArray[0] + ':' + axisArray[1]] = value
					jsonMetaDataDetailData.acceptedAt[axisArray[0] + ':' + axisArray[1]] = new Date();
					jsonMetaDataDetailData.changesViaVersion[axisArray[0] + ':' + axisArray[1]] = newversion;
					setAcceptedItms(acceptedItms + 1)

				} else {
					delete jsonMetaDataDetailData.isAccepted[axisArray[0] + ':' + axisArray[1]];
					delete jsonMetaDataDetailData.acceptedAt[axisArray[0] + ':' + axisArray[1]];
					delete jsonMetaDataDetailData.changesViaVersion[axisArray[0] + ':' + axisArray[1]];
					setAcceptedItms(acceptedItms - 1)

				}

			}


		}

		console.log('acceptedItms', acceptedItms)

		setJsonMetaData(jsonMetaDataDetailData);
		let xmlTagsList = xmlTags.map((item, i) => {
			if (i === index) {
				item.overlap[pos].isAccepted = value;

			}
			return item;
		});
		setXmlTags(xmlTagsList);
	}

	useEffect(() => {
		setDisabledSubmitButton(true)

	}, [])
	/**
	* @description function trigger when saving new pdf version
	*/

	useEffect(() => {
		console.log("Save C Data From other from other firle")
	}, [saveCData])


	const submitButton = () => {
		if (currentVersion && (version != currentVersion)) {
			toast.error('You cannot update old version.', toasterConfig);
			return

		}
		dispatch(validationAction({}))
		dispatch(tempAction({}))
		dispatch(textAction(false))
		dispatch(tagAction(false))
		dispatch(validationDataAction(false))
		setDisabledSubmitButton(true);
		setVersionLoader(true);
		const lastItem = [...fileVersions].pop();
		let newversion;
		if (!lastItem) {
			newversion = 1
		} else {
			newversion = lastItem.version + 1;
		}
		let folder_id = folder;

		var arr = [];
		var arr1 = [];
		let arr2 = [];
		// console.log('dasdasdasdasdasdasdasd')
		cTextChange.map((item, ind) => {
			arr.push({ key: Object.keys(item)[0], oldValue: item.oldValue, newValue: item.newValue })
			// arr.push(Object.keys(item)[0])
			// console.log('checinkg array new', arr)
		})

		cCheckChange.map((item, ind) => {
			arr2.push(Object.keys(item)[0])
			// console.log('checinkg array new', arr)
		});

		const newarr2 = _.uniq(arr2)



		// console.log('sadasdassdf', arr)
		const newarr = _.uniq(arr, JSON.stringify);

		cTagsChange.map(item => {
			arr1.push({ key: item.key, oldValue: item.oldValue, newValue: item.newValue })
			// arr1.push(item.split('-')[0]);
		})




		// xmlMetaDetailData.annotation.object.map((item, index) => {
		// 	item.savedName = item?.updatedName
		// }) // delete this comment



		const newarr1 = _.uniq(arr1, JSON.stringify);
		// console.log('tuesday checking result =>', cCheckChange, '=>', 'newarr', 'org=>', cTagsChange)

		// console.log('checking unique array', newarr)

		// // console.log(xmlMetaDetailObject, data, "checking xmlMetaDetailObject, data---->>>")
		// console.log({
		// 	xmlMeta: xml, base_dir: data.folder.base_dir, name: data.name, jsonMeta: jsonMetaDataDetailObject, docId: data._id, location: data.location, version: data.isDraft ?
		// 		data.latestVersion + 1 : newversion, pageNumber: pageNumber, folder_id: folder_id,
		// 	acceptedItms: data.isDraft ? (data.accepted_itms + acceptedItms) : acceptedItms, // this is used for showing c green
		// 	validation_blob: data?.validation_blob, currentVersion: currentVersion, draft: data.isDraft ? true : false
		// }, "chekidng save pdf data---->>")

		// console.log(xmlMetaDetailObject, xml, jsonMetaDataDetailObject, "checking addXmltag--->>>")
		// console.log(xmlMetaDetailObject, "checking xmlllmetaObject---")
		console.log(xmlMetaDetailObject, "xmlMetaDetailObjectxmlMetaDetailObject")

		dispatch(pdfDataSave({
			qcChange: isQCPerson ? true : false,
			updatedTextCorrect: newarr,
			updatedTagsCorrect: newarr1,
			updateTagCorrectCheck: newarr2,
			xmlMeta: xmlMetaDetailObject, base_dir: data.folder.base_dir, name: data.name, jsonMeta: jsonMetaDataDetailObject, docId: data._id, location: data.location,
			version: newversion, pageNumber: pageNumber, folder_id: folder_id,
			acceptedItms: acceptedItms, // this is used for showing c green
			is_correct: data?.is_correct,
			is_verified: data?.is_verified,
			validation_blob: data?.validation_blob, currentVersion: currentVersion, is_multi_loan: is_multi_loan
		}, ((result) => {
			if (!result?.archived) {
				if (!result?.latest_version) {
					dispatch(updateDocumentIsCorrect({ id: data?._id }, ((resultData) => {
						filterSelectedFn(null)
						sortBySelectedFn(null)
						dispatch(
							getFile({ docId: data._id, Au: null, version: newversion, pageNumber: pageNumber }, (response) => {
								// console.log('response of getFile data --> 1', response) 
								setValiadationDetail(response?.validationJson)
								_setCheckValiadation(response?.valiadationJson)
								setVersionFlag(true);
								// setVersionLoader(false);
								setChangeInputValue({}) //24 feb
								setCheckText(0)
								setCheckboxId([])
								setEditInputTagsId([])
								setEditInputBoxId([])
								setDisabledSubmitButton(true);
								setCTagsChange([]);
								setCTextChange([]);
								setCCheckChange([]);

								if (result) {
									setVersion(result.version);
									setCurrentVersion(result.version)
									setAcceptedItms(0);
									setVersionLoader(false);


								}
							}))
					})))

				} else {
					dispatch(
						getFile({ docId: data._id, Au: null, version: result.latest_version, pageNumber: pageNumber }, (response) => {
							// console.log('response of getFile data -->', response)
							setValiadationDetail(response.validationJson)
							_setCheckValiadation(response.valiadationJson)
							setVersionFlag(true);
							// setVersionLoader(false);
							setChangeInputValue({})  //24 feb
							setCheckText(0)
							setCheckboxId([])
							setEditInputTagsId([])
							setEditInputBoxId([])
							setDisabledSubmitButton(true);

							if (response) {
								setVersion(response.version);
								setCurrentVersion(response.version)
								setAcceptedItms(0);
								setVersionLoader(false);

							}
						})
					);
				}
			} else {
				setVersionLoader(false);
				history.push("/documents");
			}
		})));

		_refresh()
	}

	const submitDocumentButton = (savedTag, callBack) => {
		// console.log('submitDocumentButton runnnikng')
		if (currentVersion && (version != currentVersion)) {
			toast.error('You cannot update old version.', toasterConfig);
			return

		}
		dispatch(validationAction({}))
		dispatch(tempAction({}))
		dispatch(textAction(false))
		dispatch(tagAction(false))
		dispatch(validationDataAction(false))
		setDisabledSubmitButton(true);
		setVersionLoader(true);
		const lastItem = [...fileVersions].pop();
		let newversion;
		if (!lastItem) {
			newversion = 1
		} else {
			newversion = lastItem.version + 1;
		}
		let folder_id = folder;
		const tagArray = savedTag !== null ? [savedTag] : [];
		// console.log('checking friday', tagArray)
		// // console.log(xmlMetaDetailObject, data, "checking xmlMetaDetailObject, data---->>>")
		// console.log({
		// 	xmlMeta: xml, base_dir: data.folder.base_dir, name: data.name, jsonMeta: jsonMetaDataDetailObject, docId: data._id, location: data.location, version: data.isDraft ?
		// 		data.latestVersion + 1 : newversion, pageNumber: pageNumber, folder_id: folder_id,
		// 	acceptedItms: data.isDraft ? (data.accepted_itms + acceptedItms) : acceptedItms, // this is used for showing c green
		// 	validation_blob: data?.validation_blob, currentVersion: currentVersion, draft: data.isDraft ? true : false
		// }, "chekidng save pdf data---->>")

		// console.log(xmlMetaDetailObject, xml, jsonMetaDataDetailObject, "checking addXmltag--->>>")

		dispatch(pdfDataSave({
			updatedTagsCorrect: tagArray,
			xmlMeta: xmlMetaDetailObject, base_dir: data.folder.base_dir, name: data.name, jsonMeta: jsonMetaDataDetailObject, docId: data._id, location: data.location,
			version: newversion, pageNumber: pageNumber, folder_id: folder_id,
			acceptedItms: acceptedItms, // this is used for showing c green
			is_correct: data?.is_correct,
			is_verified: data?.is_verified,
			validation_blob: data?.validation_blob, currentVersion: currentVersion, is_multi_loan: is_multi_loan
		}, ((result) => {
			if (!result?.archived) {
				if (!result?.latest_version) {
					dispatch(updateDocumentIsCorrect({ id: data?._id }, (resultData) => {
						filterSelectedFn(null)
						sortBySelectedFn(null)
						dispatch(
							getFile({ docId: data._id, Au: null, version: newversion, pageNumber: pageNumber }, (response) => {
								console.log('response of getFile =>')
								setValiadationDetail(response.validationJson)
								setVersionFlag(true);
								// setVersionLoader(false);
								setChangeInputValue({})  //24 feb
								setCheckText(0)
								setCheckboxId([])
								setEditInputTagsId([])
								setEditInputBoxId([])
								setDisabledSubmitButton(true);

								if (response) {
									console.log('callback true hitting 0')
									setVersion(response.version);
									setCurrentVersion(response.version)
									setAcceptedItms(0);
									setVersionLoader(false);
									callBack(true)

								}
							})
						);
					}))

				} else {
					dispatch(
						getFile({ docId: data._id, Au: null, version: result.latest_version, pageNumber: pageNumber }, (response) => {

							setValiadationDetail(response.validationJson)
							setVersionFlag(true);
							// setVersionLoader(false);
							setChangeInputValue({})  //24 feb
							setCheckText(0)
							setCheckboxId([])
							setEditInputTagsId([])
							setEditInputBoxId([])
							setDisabledSubmitButton(true);

							if (response) {
								setVersion(response.version);
								setCurrentVersion(response.version)
								setAcceptedItms(0);
								setVersionLoader(false);
								callBack(true)

							}
						})
					);
				}
			} else {
				setVersionLoader(false);
				history.push("/documents");
				callBack(true)
			}
		})));

		_refresh()
	}






	/**
	* @description function trigger when validate json data
	*/
	const validateData = async (trigger = '') => {

		setVersionLoader(true);
		dispatch(validationAction({}))//empty data
		dispatch(tempAction({}))	//empty data
		dispatch(textAction(false))
		dispatch(tagAction(false))
		dispatch(validationDataAction(false));


		console.log('sellerLoanNumber', sellerLoanNumber)




		// if (invalidFields.length > 0) {
		// 	setVersionLoader(false);
		// 	const errorMessage = "Invalid values entered for the following fields: " + invalidFields.join(", ");
		// 	toast.error(
		// 		<div>
		// 			<strong style={{ fontWeight: 'bold' }}>Please Correct Below Errors</strong>
		// 			<br />
		// 			{errorMessage}
		// 		</div>
		// 	);
		// } 
		// else {
		// Proceed with saving the values

		// cnverting the currency values coming from backend as String back to Number 
		if (valiadationDetail?.processedDocument?.results) {
			const result = valiadationDetail?.processedDocument?.results;
			console.log('result.length', result.length)
			// const invalidData = [];
			for (let i = 0; i < result.length; i++) {
				let data = result[i];

				if (data?.key == 'LoanNumber') {
					valiadationDetail.loanNumber = data?.value ? data?.value : '';

				}
				if (data?.type == 'Currency') {
					// const regex = /^-?\d*\.?\d*$/;
					// if (!regex.test(data?.value)) {
					// 	invalidData.push(data?.label)
					// }
					console.log('value @!@@', data?.value, data?.label)
					if (data?.value == '') {
						console.log('running fdgjfghd', data?.value, data?.label)
						valiadationDetail.processedDocument.results[i].value = data?.value;
					} else {
						console.log('running fdgjfghd 2', Number(data?.value), data?.label)
						valiadationDetail.processedDocument.results[i].value = Number(data?.value);
					}
				}
			}
			// console.log('invalidData',invalidData)
			// // toast.error('Invalid currency amount for', invalidData.map(item => item).join(', '));
			// return;
		}

		// if(isChangeSellerLoanNumber){
		// 	valiadationDetail.loanNumber = sellerLoanNumber;
		// }
		dispatch(validateJsonData({
			organization: fileData?.organization,
			docId: fileData?._id,
			json: valiadationDetail,
			trigger: trigger
		}, ((result) => {
			// console.log("cheking result in validation data", result)
			setVersionLoader(false);
			if (result) {
				setValiadationDetail({})
				setValiadationDetail({ ...result });
			}

		})));
		// }
	}


	/**
	* @description function trigger when sendToLOS
	*/
	const sendToLOS = () => {

		dispatch({ type: "ISLOADING", data: true });
		dispatch(sendToLos({
			validationCompletionTime: formViewLOSTime != null ? formViewLOSTime + Math.round((new Date() - timer) / 1000) : Math.round((new Date() - timer) / 1000),
			organization: fileData?.organization,
			docId: fileData?._id,
			version: version
		}, ((result) => {
			if (result) {
				setOutPutGeneratedAt(result?.createdAt);
				setTimer(new Date())
				let docs = [...docRecords]
				var index = docs.findIndex(doc => doc._id == fileData?._id);
				docs[index].sentToLos = true
				docs[index].triage = false
				dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs })

			}



		})));
	}


	/**
	* @description function trigger when sentToHalcyon
	*/
	const sentToHalcyon = () => {

		dispatch({ type: "ISLOADING", data: true });
		dispatch(sendToHalcyon({
			validationCompletionTime: formViewLOSTime != null ? formViewLOSTime + Math.round((new Date() - timer) / 1000) : Math.round((new Date() - timer) / 1000),
			organization: fileData?.organization,
			docId: fileData?._id,
			version: version
		}, ((result) => {
			if (result) {
				setSentToHalcyonDisabled(true);
				setOutPutGeneratedAtHalcyon(result?.createdAt);
				setTimer(new Date())
				let docs = [...docRecords]
				var index = docs.findIndex(doc => doc._id == fileData?._id);
				docs[index].sentToHalcyon = true
				docs[index].triage = false
				dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs })

			}



		})));
	}





	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			sendToLOS();
			const button = document.getElementById('myButton');
			button.blur();
		}
	}


	/**
	* @description function trigger when sendToIA
	*/
	const sentToIA = () => {
		dispatch({ type: "ISLOADING", data: true });
		dispatch(sendToIA({
			validationCompletionTime: formViewLOSTime != null ? formViewLOSTime + Math.round((new Date() - timer) / 1000) : Math.round((new Date() - timer) / 1000),
			organization: fileData?.organization,
			docId: fileData?._id,
			version: version
		}, ((result) => {

			if (result) {
				setSentToIADisabled(true);
				setTimer(new Date())
				setOutPutGeneratedAtIA(result?.createdAt);
				let docs = [...docRecords]
				var index = docs.findIndex(doc => doc._id == fileData?._id);
				docs[index].sentToIA = true;
				docs[index].triage = false;
				dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs })

			}




		})));
	}


	/**
	* @description function trigger when sendToAnalyzer
	*/
	const sentToAnalyzer = () => {
		dispatch({ type: "ISLOADING", data: true });
		dispatch(sendToAnalyzer({
			validationCompletionTime: formViewLOSTime != null ? formViewLOSTime + Math.round((new Date() - timer) / 1000) : Math.round((new Date() - timer) / 1000),
			organization: fileData?.organization,
			docId: fileData?._id,
			version: version
		}, ((result) => {

			if (result) {
				setSentToAnalyzerDisabled(true);
				setTimer(new Date())
				setOutPutAnalyzerGeneratedAt(result?.createdAt);
				let docs = [...docRecords]
				var index = docs.findIndex(doc => doc._id == fileData?._id);
				docs[index].sentToAnalyzer = true;
				docs[index].triage = false;
				dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs })

			}




		})));
	}






	/**
	* @description function trigger when save unable to validate json data
	*/
	const _saveUnableToValidateJsonData = (data) => {
		console.log("sdasdasiweiweo")
		const lastItem = [...fileVersions].pop();
		let newversion;
		if (!lastItem) {
			newversion = 1
		} else {
			newversion = lastItem.version + 1;
		}

		setVersionLoader(true);
		setDisableUnableToUpdateButton(true);
		dispatch(saveUnableToValidateJsonData({
			validationCompletionTime: Math.round((new Date() - timer) / 1000),
			qcChange: isQCPerson ? true : false,
			organization: fileData?.organization,
			docId: fileData?._id,
			json: data,
			version: newversion
		}, ((result) => {
			setTimer(new Date())

			if (result) {
				//	history.push("/documents");
				if (!result?.archived) {
					if (!result?.latest_version) {
						dispatch(updateDocumentIsCorrect({ id: fileData?._id }, ((resultData) => {
							filterSelectedFn(null)
							sortBySelectedFn(null)
							dispatch(
								getFile({ docId: fileData._id, Au: null, version: newversion, pageNumber: pageNumber }, (response) => {
									setValiadationDetail(response.validationJson)
									setVersionFlag(true);
									// setVersionLoader(false);
									setChangeInputValue({}) //24 feb
									setCheckText(0)
									setCheckboxId([])
									setEditInputTagsId([])
									setEditInputBoxId([])
									setDisabledSubmitButton(true);
									setUnableToValidate(false);

									if (result) {
										setVersion(result.version);
										setCurrentVersion(result.version)
										setAcceptedItms(0);
										setVersionLoader(false);

									}
									setIsUnableToValidateOpen(false);
									setDisableUnableToUpdateButton(false)
									toast.success('Document successfully marked as Unable to Validate.', toasterConfig);
								}))
						})))

					} else {
						dispatch(
							getFile({ docId: fileData._id, Au: null, version: result.latest_version, pageNumber: pageNumber }, (response) => {

								setValiadationDetail(response.validationJson)
								setVersionFlag(true);
								// setVersionLoader(false);
								setChangeInputValue({})  //24 feb
								setCheckText(0)
								setCheckboxId([])
								setEditInputTagsId([])
								setEditInputBoxId([])
								setDisabledSubmitButton(true);
								setUnableToValidate(false);

								if (response) {
									setVersion(response.version);
									setCurrentVersion(response.version)
									setAcceptedItms(0);
									setVersionLoader(false);

								}
								setIsUnableToValidateOpen(false);
								setDisableUnableToUpdateButton(false);
								toast.success('Document successfully marked as Unable to Validate.', toasterConfig);
							})
						);
					}
				} else {
					setIsUnableToValidateOpen(false)
					setVersionLoader(false);
					history.push("/documents");
				}
				let docs = [...docRecords]
				var index = docs.findIndex(doc => doc._id == fileData?._id);
				docs[index].unable_to_validate = true;
				docs[index].triage = false;
				dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs })
			} else {
				setDisableUnableToUpdateButton(false);
				setVersionLoader(false);

			}

		})));
	}

	/*
	* @description function trigger when save unable to validate json data
	*/
	const revelidate = () => {

		setVersionLoader(true);
		setDisabledRevilidateButton(true);

		dispatch(revelidateDocument({
			organization: fileData?.organization,
			docId: fileData?._id,
			version: latestVersion
		}, ((result) => {
			setVersionLoader(false);
			setDisabledRevilidateButton(false);
			if (result) {
				setUnableToValidate(true)
				//history.push("/documents");
			}

		})));
	}

	const [formViewLOSTime, setFormViewLOSTime] = useState(null)

	/**
	* @description function trigger when save validate json data
	*/
	const saveValidateData = () => {
		console.log("valiadationDetail", valiadationDetail)
		setDisabledInputTagsText(true)
		setVersionLoader(true);
		dispatch(validationAction({}))//empty data
		dispatch(tempAction({}))	//empty data
		dispatch(textAction(false))
		dispatch(tagAction(false))
		dispatch(validationDataAction(false))

		// if (invalidFields.length > 0) {
		// 	setVersionLoader(false);
		// 	setDisabledInputTagsText(false)
		// 	const errorMessage = "Invalid values entered for the following fields: " + invalidFields.join(", ");
		// 	toast.error(
		// 		<div>
		// 			<strong style={{ fontWeight: 'bold' }}>Please Correct Below Errors</strong>
		// 			<br />
		// 			{errorMessage}
		// 		</div>
		// 	);
		// } 
		// else {


		const lastItem = [...fileVersions].pop();
		let newversion;
		if (!lastItem) {
			newversion = 1
		} else {
			newversion = lastItem.version + 1;
		}

		// converting the currency values coming from backend as String back to Number
		if (valiadationDetail?.processedDocument?.results) {
			const result = valiadationDetail?.processedDocument?.results;
			console.log('result.length', result.length)
			for (let i = 0; i < result.length; i++) {
				let dataDetail = result[i];
				if (dataDetail?.key == 'LoanNumber') {
					valiadationDetail.loanNumber = dataDetail?.value ? dataDetail?.value : '';
					if (!isChangeSellerLoanNumber && data?.src != 'LOS') {
						if ((data.loan_number != valiadationDetail.loanNumber) && !(data.loan_number == 'no-loan-number' && valiadationDetail.loanNumber == '')) {

							isChangeSellerLoanNumber = true;
							sellerLoanNumber = valiadationDetail.loanNumber;
						}

					}

				}
				if (dataDetail?.type == 'Currency' || dataDetail?.type == 'Number' || dataDetail?.type == 'Decimal') {
					console.log(dataDetail?.value, "valiadationDetail")
					if (dataDetail?.value?.length === 0) {
						delete valiadationDetail.processedDocument.results[i].value;
						//valiadationDetail.processedDocument.results[i].value = ''
					} else {
						valiadationDetail.processedDocument.results[i].value = Number(dataDetail?.value);

					}
				}
			}
		}

		/*if(isChangeSellerLoanNumber){
			valiadationDetail.loanNumber = sellerLoanNumber;
		}*/

		console.log("fileDataId", fileData?._id)
		console.log("valiadationDetail", valiadationDetail)
		dispatch(saveValidateJsonData({
			qcChange: isQCPerson ? true : false,
			updatedTagValidate: vTextChange,
			updateTagValidateCheck: vCheckChangeY,
			updateTagValidateCheckN: vCheckChangeN,
			updateTagErrorValidate: vErrorsChange,
			organization: fileData?.organization,
			docId: fileData?._id,
			json: valiadationDetail,
			version: newversion,
			sellerLoanNumber: sellerLoanNumber,
			isChangeSellerLoanNumber: isChangeSellerLoanNumber,
			validationCompletionTime: Math.round((new Date() - timer) / 1000)
		}, ((result) => {
			setTimer(new Date());
			setDisabledInputTagsText(false)
			if (result?.archived || isChangeSellerLoanNumber) {
				setVersionLoader(false);
				history.push("/documents");

			} else {

				let docs = [...docRecords]
				var index = docs.findIndex(doc => doc._id == fileData?._id);
				if (docs[index]?.unable_to_validate) {
					delete docs[index]?.unable_to_validate;
				}
				if (result?.updated_document_detail) {
					docs[index].sentToLos = result?.updated_document_detail?.sentToLos;
					docs[index].sentToIA = result?.updated_document_detail?.sentToIA;
					docs[index].sentToAnalyzer = result?.updated_document_detail?.sentToAnalyzer;
					docs[index].sentToHalcyon = result?.updated_document_detail?.sentToHalcyon;
					if(result?.updated_document_detail?.green_v_achieved){
						docs[index].green_v_achieved = result?.updated_document_detail?.green_v_achieved;
					}else{
						delete docs[index]?.green_v_achieved;

					}
					


				}
				dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs });

				if (result?.version_updating) {
					setVersionLoader(false);

				} else if (!result?.latest_version) {
					console.log('data is saving when clicked on save')
					dispatch(

						getFile({ docId: data._id, Au: null, version: newversion, pageNumber: pageNumber }, (response) => {
							console.log('get File api response -->', response.validationJson)
							if (response.is_verified != 2) {
								setFormViewLOSTime(Math.round((new Date() - timer) / 1000))
							}
							setIsChangeSellerLoanNumber(false)
							dispatch({ type: "SET_RIGHTSIDEBAR", data: "V" });//this is used to display prefilled data in tags in draft mode also used to display prefilled data if we save draft data , also to enable Save button
							setValiadationDetail(response.validationJson)
							setVersionFlag(true);
							// setVersionLoader(false);
							setChangeInputValue({}) //24 feb
							setCheckText(0)
							setCheckboxId([])
							setEditInputTagsId([])
							setEditInputBoxId([]);
							setVTextChange([]);
							setVCheckChangeY([]);
							setVCheckChangeN([]);
							setVErrorsChange([]);
							setDisabledSubmitButton(true);
							if (response) {
								setVersion(response.version);
								setCurrentVersion(response.version)
								setAcceptedItms(0);
								setVersionLoader(false);

							}
						}))

				} else {
					dispatch(
						getFile({ docId: data._id, Au: null, version: result.latest_version, pageNumber: pageNumber }, (response) => {
							if (response.is_verified != 2) {
								setFormViewLOSTime(Math.round((new Date() - timer) / 1000))
							}
							dispatch({ type: "SET_RIGHTSIDEBAR", data: "V" });//this is used to display prefilled data in tags in draft mode also used to display prefilled data if we save draft data , also to enable Save button
							setIsChangeSellerLoanNumber(false)
							setValiadationDetail(response.validationJson)

							setVersionFlag(true);
							// setVersionLoader(false);
							setChangeInputValue({}) //24 feb
							setCheckText(0)
							setCheckboxId([])
							setEditInputTagsId([])
							setEditInputBoxId([])
							setDisabledSubmitButton(true);
							if (response) {
								setVersion(response.version);
								setCurrentVersion(response.version)
								setAcceptedItms(0);
								setVersionLoader(false);

							}
						})
					);
				}
			}

		})));
		// }
		setTimer(new Date())
	}

	/**
		* @description function trigger when process validate data
		*/
	const processValidateData = () => {

		setVersionLoader(true);
		dispatch(validationAction({})) //empty data
		dispatch(tempAction({}))	//empty data
		dispatch(textAction(false))
		dispatch(tagAction(false))
		dispatch(validationDataAction(false))
		const lastItem = [...fileVersions].pop();

		dispatch(processValidation({
			organization: fileData?.organization,
			docId: fileData?._id,
			versionId: fileData?.versionId
		}, ((result) => {
			if (result) {
				dispatch(
					getFile({ docId: data._id, Au: null, version: lastItem.version, pageNumber: pageNumber }, (response) => {


						setValiadationDetail(response.validationJson)
						setVersionFlag(true);
						// setVersionLoader(false);
						setChangeInputValue({}) //24 feb
						setCheckText(0)
						setCheckboxId([])
						setEditInputTagsId([])
						setEditInputBoxId([])
						setDisabledSubmitButton(true);
						if (response) {
							setVersion(response.version);
							setCurrentVersion(response.version)
							setAcceptedItms(0);
							setVersionLoader(false);

						}
					})
				);
			} else {
				setVersionLoader(false);
			}

		})));
	}



	const generateOutputData = () => {



		setVersionLoader(true);

		const lastItem = [...fileVersions].pop();

		dispatch(generateOutput({
			organization: fileData?.organization,
			docId: fileData?._id,
			versionId: fileData?.versionId
		}, ((result) => {
			if (result) {
				// console.log('result', result)
			} else {
				setVersionLoader(false);
			}

		})));
	}




	/**
	* @description function trigger when changing new pdf version
	*/
	const changeVersion = (val, reset) => {

		setDisabledSubmitButton(true)
		setVersionLoader(true);
		const lastItem = [...fileVersions].pop();
		setCurrentVersion(val)
		dispatch(
			getFile({ docId: data._id, Au: null, version: val, pageNumber: pageNumber }, (response) => {
				setAcceptedItms(0);
				setCheckboxId([])

				setValiadationDetail(response?.validationJson)
				setJsonMetaData(response?.json)
				setXmlMeta(response?.xml)
				setVersionFlag(true);
				setDisabledInputTagsText(false)
				// setVersionLoader(false);
				let currentVerionDetail = fileVersions.find((item) => {
					if (item.version == val) {
						return item;
					}
				});
				if (currentVerionDetail) {
					setCreatedUser(currentVerionDetail?.user ? (currentVerionDetail?.user?.fname + ' ' + currentVerionDetail?.user?.lname) : (isAdminLoggedIn ? currentVerionDetail?.admin?.fname + ' ' + currentVerionDetail?.admin?.lname : "Mori Support"));
					setUpdatedAt(currentVerionDetail?.createdAt)
				} else {
					setCreatedUser(fileData?.folder?.user ? (fileData?.folder?.user?.fname + ' ' + fileData?.folder?.user?.lname) : (isAdminLoggedIn ? fileData?.folder?.admin?.fname + ' ' + fileData?.folder?.admin?.lname : "Mori Support"))
					setUpdatedAt(fileData?.createdAt)
				}
				if ((val == lastItem.version) || reset == 'resetToOriginal') {
					setDisabledInputTagsText(false)
					setCheckText(0)
				} else {
					setDisabledInputTagsText(true)
					setCheckText(0)
				}
				_refresh()
				setVersionLoader(false);
				setUnableToValidate(false)


			})
		);


	}

	const changeRevision = (val) => {
		setDisabledSubmitButton(true)
		setVersionLoader(true);
		const lastItem = [...fileVersions].pop();
		dispatch(
			getFileByRevision({ docId: val, Au: null, pageNumber: pageNumber }, (response) => {
				setAcceptedItms(0);
				setCheckboxId([])
				setCurrentVersion(response.version)
				setValiadationDetail(response.validationJson)
				setVersionFlag(true);
				dispatch({ type: "SELECTED_REVISION", data: val })
				let index = docRecords?.findIndex(obj => obj._id === fileData?._id);

				// Check if the object with the specified _id exists in the array
				if (index !== -1) {
					// Replace the old object with the new one
					docRecords[index] = response;
				}

				dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docRecords })

				// setVersionLoader(false);
				let currentVerionDetail = fileVersions.find((item) => {
					if (item.version == val) {
						return item;
					}
				});
				if (currentVerionDetail) {
					setCreatedUser(currentVerionDetail?.user ? (currentVerionDetail?.user?.fname + ' ' + currentVerionDetail?.user?.lname) : (isAdminLoggedIn ? currentVerionDetail?.admin?.fname + ' ' + currentVerionDetail?.admin?.lname : "Mori Support"));
					setUpdatedAt(currentVerionDetail?.createdAt)
				} else {
					setCreatedUser(fileData?.folder?.user ? (fileData?.folder?.user?.fname + ' ' + fileData?.folder?.user?.lname) : (isAdminLoggedIn ? fileData?.folder?.admin?.fname + ' ' + fileData?.folder?.admin?.lname : "Mori Support"))
					setUpdatedAt(fileData?.createdAt)
				}
				setDisabledInputTagsText(false)
				setCheckText(0)
				if (response?.revision == latestRevision) {
				}
				else {
					setDisabledInputTagsText(true)
					setCheckText(0)
				}
				_refresh()
				setVersionLoader(false);
				setUnableToValidate(false)


			})
		);
	}

	const isValueInString = async (value, csvString) => {
		// Convert the comma-separated string into an array
		const valuesArray = csvString.split(',').map(item => item.trim());

		// Check if the value exists in the array
		return valuesArray.includes(value);
	}

	const checkXmlTagPage = async (val) => {
		if (val) {
			// console.log(val[0]?.tag, "xmlData")
			// eslint-disable-next-line no-unused-expressions
			fileData?.xmlTagsPerUrl.forEach(async (element, index) => {
				let valueInString = await isValueInString(val[0]?.tag, element);
				if (valueInString) {
					setEditTabsVal()
					setsScrollHeight({ x: null, y: null })
					if (index + 1 !== pageNumber) {
						changePage(index + 1);
					} else {
						redirectToTag(val)
					}
				}
			});
		}
	}
	useEffect(() => {
		// console.log(pageChanged, "timeout2759")
		if (xmlTags && tagValue && pageChanged) {
			xmlTags.forEach(el => {
				// console.log(el?.tag === tagValue[0]?.tag, "timeOut2759");
				if (el?.tag === tagValue[0]?.tag) {
					setTimeout(() => {
						el.overlap.forEach(overlap => {
							setEditTabsVal(overlap.id);
							setsScrollHeight({ x: el.bounds.x / 2, y: el.bounds.y / 2 });
							setPageChanged(false)
						});
					}, 2000);
				}
			});
		}
	}, [pageNumber, xmlTags, pageChanged]);

	const redirectToTag = async (val) => {

		xmlTags.forEach(el => {
			if (el?.tag == val[0]?.tag) {
				// console.log("not timeOut")
				el.overlap.forEach(overlap => {
					setEditTabsVal(overlap.id);
					setsScrollHeight({ x: el.bounds.x / 2, y: el.bounds.y / 2 });
				});
			}
		});
	}

	/**
	* @description function trigger when changing pad page
	*/
	const changePage = async (val) => {
		setXmlTags((p) => p = []) // reset after changing page
		// setOriginalXmlTags((p) => p = [])

		setPageNumber(val);

		setVersionLoader(true);
		// setIsPageChange(true)

		const lastItem = [...fileVersions].pop();
		if (jsonMetaDataDetailObject[val]) {
			dispatch(set_page_number(val));
			setVersionFlag(true);
			jsonMetaDataDetail = jsonMetaDataDetailObject[val];
			setJsonMetaData(jsonMetaDataDetail);
			xmlMetaDetail = xmlMetaDetailObject[val];
			setXmlMeta(xmlMetaDetail);
			setVersionLoader(false);
		} else {
			dispatch(
				getFilePage({ docId: data._id, Au: null, version: currentVersion, pageNumber: val, isDraft: data.isDraft ? true : false }, (response) => { //isDraft is used to hit temp file api if data is present in draft
					setVersionFlag(true);
					let currentVerionDetail = fileVersions.find((item) => {
						if (item.version == currentVersion) {
							return item;
						}
					});
					if (currentVerionDetail) {

						setCreatedUser(currentVerionDetail?.user ? (currentVerionDetail?.user?.fname + ' ' + currentVerionDetail?.user?.lname) : (isAdminLoggedIn ? currentVerionDetail?.admin?.fname + ' ' + currentVerionDetail?.admin?.lname : "Mori Support"));
						setUpdatedAt(currentVerionDetail?.createdAt)
						_refresh()
						// setVersionLoader(false);
					} else {

						setCreatedUser(fileData?.folder?.user ? (fileData?.folder?.user?.fname + ' ' + fileData?.folder?.user?.lname) : (isAdminLoggedIn ? fileData?.folder?.admin?.fname + ' ' + fileData?.folder?.admin?.lname : "Mori Support"))
						setUpdatedAt(fileData?.createdAt)
						// setVersionLoader(false);
					}
				})
			);

		}

		_refresh();
		// setTimeout(() => {
		// 	setVersionLoader(false);
		// }, 2000)


		// 			setCreatedUser(fileData?.folder?.user?.fname + ' ' + fileData?.folder?.user?.lname)
		// 			setUpdatedAt(fileData?.createdAt)
		// 		}
		// 	})
		// );
		// _refresh();

		//22feb
		let newversion
		if (!lastItem) {
			newversion = 1
		} else {
			newversion = lastItem.version + 1;
		}
		// dispatch(tempAction({
		// 	...data, xmlMeta2: xmlMetaDetailObject,
		// 	json2: jsonMetaDataDetailObject, pageNumber: pageNumber,
		// 	current_version: false, version: newversion, folder_id: folder


		// }))


		// }
		setPageChanged(true)
	}


	const [isChangingPage, setIsChangingPage] = useState(false);

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (!isChangingPage) {
				setIsChangingPage(true);
				if (event.keyCode === 37 && Number(pageNumber) > 1) { // Left arrow key
					changePage(Number(pageNumber) - 1);
				} else if (event.keyCode === 39 && Number(pageNumber) < Number(pdfPagesCount)) { // Right arrow key
					changePage(Number(pageNumber) + 1);
				}
				setTimeout(() => {
					setIsChangingPage(false);
				}, 500); // Adjust the delay time as needed (e.g., 500ms)
			}
		};

		window.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [pageNumber, pdfPagesCount, isChangingPage]);

	/**
	 * @description method call to soft delete Operator 
	 * @returns 
	 */
	const deleteDocumentType = () => {
		MySwal.fire({
			title: 'Are you sure?',
			text: "You want to delete this document type ",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, delete it!'
		}).then((result) => {

			if (result.isConfirmed) {
				dispatch(updateDocumentType({ id: fileData._id, type: null }, (res) => {
					if (res) {
						setIsDocumentTypeSelected(false);
						setValue('');
						filterSelectedFn(null)
						sortBySelectedFn(null)
						toast.success('Document type has been deleted.', toasterConfig);

					}
				}))
			}
		})

	}






	/**
	 * @description method call to check is_verifed green or red
	 * @returns 
	 */
	const isVerified = () => {
		if (data?.output_blob_url && fileData?.is_verified != 2) {
			toggle('3');
		} else if (fileData?.is_verified == 2) {
			toast.error('Please correct validation first', toasterConfig);
		} else {
			toast.error('File not generated for this version', toasterConfig);
		}

	}

	/**
	 * @description function to populate Audit Log tab
	 * @returns 
	 */
	const DocumentLogListing = () => {

	}


	// load pdf to dom
	useEffect(() => {
		let isMounted = true;
		const loadPDF = async () => {

			if (data?.file_type && data?.file_type?.toLowerCase() !== 'pdf') {
				try {
					const base64String = Buffer.from(data?.pdf_url_buffer?.data, 'binary').toString('base64')
					let pdfDim = await addImageProcess(base64String);
					// setTimeout(() => {
					calculateIdleScale(pdfDim)
					// }, 1000);
					setPdf(await addImageProcess(base64String))
					if (data?.output_blob_url) {
						// let outputpdfdocument = await PDFJS.getDocument(data?.output_blob_url).promise;
						// console.log('outputpdfdocument', outputpdfdocument)

						const buffer = new Uint8Array(data?.output_blob_url?.data);
						let outputpdfdocument = await pdfjsLib.getDocument({ data: buffer }).promise
						setGenerateOutputPdf(outputpdfdocument)
					}
				} catch (err) { // when the file_type is not img, cross checking if it may work with pdf type
					if (data?.pdf_url_buffer) {
						const buffer = new Uint8Array(data?.pdf_url_buffer?.data);
						let pdfdocument = await pdfjsLib.getDocument({ data: buffer }).promise
						// let pdfdocument = await PDFJS.getDocument(data.pdf_url).promise;
						let pdfDim = await pdfProcess(pdfdocument, pageNumber, 1);
						calculateIdleScale(pdfDim);
						if (data?.output_blob_url) {
							// let outputpdfdocument = await PDFJS.getDocument(data?.output_blob_url).promise
							const buffer = new Uint8Array(data?.output_blob_url?.data);
							let outputpdfdocument = await pdfjsLib.getDocument({ data: buffer }).promise
							setGenerateOutputPdf(outputpdfdocument);
						}
						if (isMounted) {
							console.log("pdfdocument", pdfdocument.numPages)
							setPdf(pdfdocument)
							setPdfPagesCount(pdfdocument.numPages)
						}

					}
				}
			} else {
				if (data?.pdf_url_buffer) {
					console.log('this part running sdasdasd-->')
					const buffer = new Uint8Array(data?.pdf_url_buffer?.data);
					let pdfdocument = await pdfjsLib.getDocument({ data: buffer }).promise
					// let pdfdocument = await PDFJS.getDocument(data.pdf_url).promise;
					let pdfDim = await pdfProcess(pdfdocument, pageNumber, 1);
					calculateIdleScale(pdfDim);
					if (data?.output_blob_url) {
						// let outputpdfdocument = await PDFJS.getDocument(data?.output_blob_url).promise
						const buffer = new Uint8Array(data?.output_blob_url?.data);
						let outputpdfdocument = await pdfjsLib.getDocument({ data: buffer }).promise
						setGenerateOutputPdf(outputpdfdocument);
					}
					if (isMounted) {
						console.log("pdfdocument", pdfdocument.numPages)
						setPdf(pdfdocument)
						setPdfPagesCount(pdfdocument.numPages)
					}

				}

			}
			if (isMounted) {
				_refresh()
			}
		}
		if (isMounted) {
			loadPDF();
			dispatch(tagPanelAction(false));
		}
		return () => {
			isMounted = false;
		};
	}, [dispatch, data?.pdf_url_buffer?.data, data?.output_blob_url])


	useEffect(() => {
		let currentVerionDetail = fileVersions.find((item) => {
			if (item.version == version) {
				return item;
			}
		});
		if (currentVerionDetail) {
			setCreatedUser(currentVerionDetail?.user ? (currentVerionDetail?.user?.fname + ' ' + currentVerionDetail?.user?.lname) : (isAdminLoggedIn ? currentVerionDetail?.admin?.fname + ' ' + currentVerionDetail?.admin?.lname : "Mori Support"));
			setUpdatedAt(currentVerionDetail?.createdAt)
		} else {
			setCreatedUser(fileData?.folder?.user ? (fileData?.folder?.user?.fname + ' ' + fileData?.folder?.user?.lname) : (isAdminLoggedIn ? fileData?.folder?.admin?.fname + ' ' + fileData?.folder?.admin?.lname : "Mori Support"))
			setUpdatedAt(fileData?.createdAt)
		}

	}, [version])

	const processClickId = (val, flag) => {
		setUniId('')
		setUniId(val);
		setOutSide(flag)

	}



	const [tooltipVisible, setTooltipVisible] = useState(false);
	const closeRightSideBar = () => {
		let items = document.querySelectorAll('left-item-selected');
		// Using forEach loop
		items.forEach(function (item) {
			item.classList.remove('left-item-selected');
		});

		dispatch(rightsidebar('D'));
	}

	const onMouseEnterHandler = () => {
		if (value) {
			const inputBlcElem = document.getElementById('inputBlc');
			const inputBlcElemLeftPosition = document.getElementById('inputBlc').getBoundingClientRect().left;
			const inputBlcElemTopPosition = document.getElementById('inputBlc').getBoundingClientRect().top;
			const labelDropdownElem = document.getElementById('labelTooltip');


			labelDropdownElem.style.left = inputBlcElemLeftPosition + 'px';
			labelDropdownElem.style.top = inputBlcElemTopPosition + 'px';

			setTooltipVisible(true);

			labelDropdownElem.style.marginTop = - labelDropdownElem.clientHeight + 'px';

		}

	}
	const onMouseLeaveHandler = () => {
		if (value) {
			setTooltipVisible(false);
		}
	}

	useEffect(() => {
		setJsonMetaData(jsonMetaDataDetail)
		setXmlMeta(xmlMetaDetail);
	}, [xmlMetaDetail]);

	const CustomHeader = (props) => {
		return (
			<div style={{
				fontWeight: `${props.node.children?.length ? 'bold' : ''}`,
				fontSize: 12
			}}
				className={`${props.node.children?.length ? 'sd-header' : 'sd-childs'}`}>
				{props.node.name}
			</div>
		);
	}

	const onClick = (value) => {
		setIsComponentVisible(true)
		const filter = value?.trim();
		decorators.Header = CustomHeader
		defaultTheme.tree.node.activeLink.background = 'red';
		if (!filter) {
			setDropdownData(dropData);
		} else {
			let filtered = filters.filterTree(dropData, filter);
			filtered = filters.expandFilteredNodes(filtered, filter);
			setDropdownData(filtered);
		}
	}

	const unAssignDocument = () => {
		const textValue = `Would you like to unassign this document?`
		MySwal.fire({
			title: "Are you sure?",
			text: textValue,
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes",
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(unAssignDoc({ docId: fileData._id, assignedBy: userDetail._id, assignedTo: fileData.assignedTo, user: userDetail }, (res) => {
					if (res) {
						setUnAssignDisable(true)
						// toast.success('Document unassign successfully.', toasterConfig);
					}
				}))
				console.log("Assinged to you")
			}
		});
	}

	/**
	 * @description function trigger when click on Mark Completed Button
	 */

	const markCompleted = () => {
		MySwal.fire({
			title: "Mark as Complete",
			text: "Are you sure you want to Mark this complete?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes",
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(updateCompleteStatus({
					validationCompletionTime: Math.round((new Date() - timer) / 1000),
					qcChange: isQCPerson ? true : false,
					docId: fileData?._id,
					version: latestVersion
				}, (res) => {
					setTimer(new Date())
					let docs = [...docRecords]
					var index = docs.findIndex(doc => doc._id == fileData?._id);
					docs[index].complete = true;
					docs[index].triage = false;
					dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs })
				}))
			}
		})
	}

	const triageDocument = () => {
		MySwal.fire({
			title: "Triage Document",
			html: `
      			<input type="text" id="triageReason" class="swal2-input" placeholder="Type Reason for Triage" style="max_width: 100%; margin-bottom: 10px;" />
      			<p>Are you sure you want to Triage this document?</p>
    		`,
			text: "Are you sure you want to Triage this document?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes", preConfirm: () => {
				const reason = document.getElementById('triageReason').value;
				if (!reason) {
					MySwal.showValidationMessage('You need to provide a reason to proceed');
					return false;
				}
				return reason;  // Return the reason if input is valid
			}
		}).then((result) => {
			if (result.isConfirmed) {
				const reason = result.value
				dispatch(saveAsTriage({
					// validationCompletionTime: Math.round((new Date() - timer) / 1000),
					qcChange: isQCPerson ? true : false,
					docId: fileData?._id,
					version: latestVersion,
					triageReason: reason
				}, (res) => {
					// setTimer(new Date())
					let docs = [...docRecords]
					var index = docs.findIndex(doc => doc._id == fileData?._id);
					docs[index].triage = true
					dispatch({ type: "UPDATE_DOCUMENT_LIST", data: docs })
				}))
			}
		})
	}


	const [modal, setModal] = useState(false);
	const modalToggleHandle = () => setModal(!modal);


	return (
		<>
			{/* {console.log('cTextChange array status', cTextChange)} */}

			<div className={`sidebarListOverlay ${(navigationState) ? 'active' : ''}`} onClick={overClickHandler}></div>
			<div className={`tagPanelOverlay ${istagPanelVisible ? 'active' : ''}`} onClick={tagPanelOverlayHandler}></div>
			<div className={`document-view-blc d-flex flex-fill overflow-auto ${!loader ? "loaderVisible" : ""}`} >
				<div className="left-col d-flex flex-fill flex-column overflow-auto position-relative">
					<Nav tabs>
						<div className={`left-col d-flex flex-wrap${!loader ? " disable" : ""}`}>
							{/* {console.log('VIEWING FILE => ', view)} */}
							{view ?
								<span className="observing-icon rounded-circle">
									<lottie-player src="https://assets9.lottiefiles.com/private_files/lf30_qel9twkl.json" background="transparent" speed="1" loop autoplay title="Someone else is viewing this document."></lottie-player>
								</span> : null}
							<NavItem>
								<NavLink
									className={classnames({ active: activeTab === '1' })}
									onClick={() => { toggle('1'); }}
								>
									OCR View
								</NavLink>
							</NavItem>
							{currentDocument?.packet_type && <NavItem>
								<NavLink
									className={classnames({ active: activeTab === '2' })}
									onClick={() => { toggle('2'); }}
								>
									Document View
								</NavLink>
							</NavItem>}
							{currentDocument?.packet_type && (fileData?.packet_type?.send_to_los || fileData?.packet_type?.send_to_ia || fileData?.packet_type?.send_to_halcyon)/*&&  fileData?.packet_type?.ml_ref != 'purchase_advice'*/ &&
								<NavItem>
									<NavLink
										className={classnames({ active: activeTab === '3' })}
										onClick={() => { isVerified('3'); }}
									>
										Form View
									</NavLink>
								</NavItem>
							}
							{currentDocument && <NavItem>
								<NavLink
									className={classnames({ active: activeTab === '4' })}
									onClick={() => { toggle('4'); }}
								>
									Audit Log
								</NavLink>
							</NavItem>}

						</div>
						<div className="right-col responsive-menu-btn ms-auto d-flex align-items-center">
							{activeTab == "1" &&

								<div
									style={{ marginRight: "13px", cursor: "pointer", position: "relative" }}
									onClick={() => {
										// Check if the docAssist window is already open
										if (window.docAssistWindow && !window.docAssistWindow.closed) {
											// Bring the existing window into focus
											window.docAssistWindow.focus();
											return;
										}

										const documentTypeId = data?.packet_type?._id;
										const organizationId = data?.organization;
										const width = window.innerWidth * 0.5;
										const height = window.innerHeight * 0.8;
										const gap = 20;
										const left = window.innerWidth - width - gap;
										const top = window.innerHeight - height + 2 * gap;

										// Open a new window with a fixed target name
										window.docAssistWindow = window.open(
											`/docAssistRules?packetId=${documentTypeId}&orgId=${organizationId}`,
											"docAssistRules", // fixed window name so that it reuses the same window
											`width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
										);

										// Update your Redux or local state accordingly
										dispatch({ type: "OPENED_TAB", data: [window.docAssistWindow] });
										setOpenedWindow([window.docAssistWindow]);
									}}

									title="View Rules"
								>
									<img src={RulesIcon} alt="Rules Icon" style={{ width: '25px', height: '25px' }} />
								</div>
							}
							<div className={`label-dropdown-blc position-relative${!loader ? " disable" : ""}`}>
								{/*activeTab === '1' && isDocumentTypeSelected &&
									<Button color="link" className='close-btn position-absolute p-0' onClick={() => deleteDocumentType()}>
										<FontAwesomeIcon icon={faClose} />
									</Button>
							*/}
								{activeTab === '1' && <div ref={refrence}>
									<div className="input-blc" id="inputBlc"
										onMouseEnter={onMouseEnterHandler}
										onMouseLeave={onMouseLeaveHandler}>
										<Input
											className="form-control"
											value={value}
											onClick={(e) => { onClick(e.target.value) }}
											onChange={(e) => { setValue(e.target.value) }}
											onKeyUp={onFilterMouseUp.bind(this)}
											placeholder="Select File Label"
											type="text"
											disabled={fileData?.read_only} // true will handele in next phase for labeled document without packet type

										/>
										{
											value ? <div
												className={`label-tooltip position-fixed ${tooltipVisible ? 'active' : ''}`}
												id="labelTooltip">
												{value}
											</div> : ''
										}

									</div>
									{dropdownData?.children?.length !== 0 && isComponentVisible ? <Treebeard data={dropdownData} onToggle={onToggle} decorators={decorators} defaultTheme={defaultTheme} /> : null}
								</div>
								}
							</div>
							{activeTab === '1' &&
								<div style={{ marginRight: "13px" }}>
									<RevisionDropdown inputDisabled={fileData?.read_only}
										options={revisions}
										original={fileData?.isRevision ? fileData?.revisionParent : fileData?._id}
										val={fileData?._id}
										handleVal={(val) => changeRevision(val)}
										loader={loader}
									/>
								</div>}
							{currentDocument?.packet_type && activeTab === '1' &&
								<VersionDropdown inputDisabled={fileData?.read_only}
									options={fileVersions}
									// val={version}
									val={latestVersion} //issue (382)
									handleVal={(val) => changeVersion(val)}
									loader={loader}
								/>
							}


							{currentDocument?.packet_type && activeTab === '2' && !is_multi_loan &&
								<div style={{ marginRight: "15px" }}>
									<PdfPageDropdown
										handleVal={(val) => changePage(val)}
										val={selectedPage}
										pdfPagesCount={pdfPagesCount} /></div>}

							{currentDocument?.packet_type && activeTab === '2' && <PdfControls _refresh={_refresh} _zoomInOcr={(val) => _zoomInOcr(val)} _zoomOutOcr={(val) => _zoomOutOcr(val)} _activeEditTabs={activeEditTabs} activeLink={activeLinkDoc} disabledZoomFlag={disabledZoomFlagDoc} disabledZoomInButton={disabledZoomInButtonDoc} disabledZoomOutButton={disabledZoomOutButtonDoc} />
								// activeTab === '2' && <PdfControls _refresh={_refresh} _zoomInOcr={(val) => _zoomInOcr(val)} _zoomOutOcr={(val) => _zoomOutOcr(val)} _activeEditTabs={activeEditTabs} activeLink={activeLink} disabledZoomFlag={disabledZoomFlag} disabledZoomInButton={disabledZoomInButton} disabledZoomOutButton={disabledZoomOutButton} />
							}
							{activeTab === '2' &&
								<div style={{ marginRight: "13px" }}>
									<RevisionDropdown inputDisabled={fileData?.read_only}
										options={revisions}
										original={fileData?.isRevision ? fileData?.revisionParent : fileData?._id}
										val={fileData?._id}
										handleVal={(val) => changeRevision(val)}
										loader={loader}
									/></div>}
							{currentDocument?.packet_type && activeTab === '2' &&
								<div style={{ marginLeft: "15px" }}>
									<VersionDropdown inputDisabled={fileData?.read_only}
										options={fileVersions}
										// val={version}

										val={latestVersion} //issue (382)
										handleVal={(val) => changeVersion(val)}
										loader={loader}
									/></div>}


							<Button color="link" disabled={!loader ? true : false} className="toggle-btn" onClick={navigationHandler}>
								<FontAwesomeIcon icon={faBars} />
							</Button>


							<BackButton className="ms-auto" onClick={() => backClick()} />

						</div>
					</Nav>
					<TabContent activeTab={activeTab}
						className={` flex-fill overflow-auto 
						${activeTab === "1" ? 'ocr-view-tabContent' : ''}
						${activeTab === "2" ? 'document-view-tabContent' : ''}
						`}>
						{activeTab == 3 ? <TabPane tabId="3" className='ocr-tabPane' ref={ref}>
							{data?.packet_type?.send_to_los &&
								<span>
									<Button id="myButton" className={`btn btn-outline-success btn-los`} onClick={() => sendToLOS()} onKeyDown={(e) => handleKeyPress(e)} color='link' >
										Send to LOS
									</Button>
									{outPutGeneratedAt || data?.fileVersions[data?.fileVersions.length - 1]?.outPutGeneratedAt ? <label className='send-date-label'>Sent to LOS:</label> : ''}
									{outPutGeneratedAt ?
										((outPutGeneratedAt && userDetail?.timezone) ?
											<><TimezoneClock timezone={userDetail.timezone} dateTime={outPutGeneratedAt} timeFormat={"MM/DD/YYYY h:mm A"} /></>
											:
											moment(outPutGeneratedAt).format(
												"MM/DD/YYYY"
											) + ' ' + moment(outPutGeneratedAt).format(
												"h:mm A"
											))
										:
										((data?.fileVersions[data?.fileVersions.length - 1]?.outPutGeneratedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={data?.fileVersions[data?.fileVersions.length - 1]?.outPutGeneratedAt} timeFormat={"MM/DD/YYYY h:mm A"} /></> :
											(data?.fileVersions[data?.fileVersions.length - 1]?.outPutGeneratedAt ? moment(data?.fileVersions[data?.fileVersions.length - 1]?.outPutGeneratedAt).format(
												"MM/DD/YYYY"
											) + ' ' + moment(data?.fileVersions[data?.fileVersions.length - 1]?.outPutGeneratedAt).format(
												"h:mm A"
											) : ''))}
								</span>}
							{data?.packet_type?.send_to_analyzer && (
								<span>
									<Button
										disabled={data?.sentToAnalyzer || SentToAnalyzerDisabled}
										className="btn btn-outline-success btn-los"
										onClick={sentToAnalyzer}
										color="link"
									>
										Send to Analyzer
									</Button>

									{(outPutAnalyzerGeneratedAt ||
										data?.fileVersions?.[data?.fileVersions?.length - 1]
											?.outPutAnalyzerGeneratedAt) && (
											<>
												<label className="send-date-label">Sent to Analyzer:</label>

												{outPutAnalyzerGeneratedAt ? (
													userDetail?.timezone ? (
														<TimezoneClock
															timezone={userDetail.timezone}
															dateTime={outPutAnalyzerGeneratedAt}
															timeFormat="MM/DD/YYYY h:mm A"
														/>
													) : (
														moment(outPutAnalyzerGeneratedAt).format("MM/DD/YYYY h:mm A")
													)
												) : userDetail?.timezone ? (
													<TimezoneClock
														timezone={userDetail.timezone}
														dateTime={
															data?.fileVersions?.[data?.fileVersions?.length - 1]
																?.outPutAnalyzerGeneratedAt
														}
														timeFormat="MM/DD/YYYY h:mm A"
													/>
												) : (
													moment(
														data?.fileVersions?.[data?.fileVersions?.length - 1]
															?.outPutAnalyzerGeneratedAt
													).format("MM/DD/YYYY h:mm A")
												)}
											</>
										)}
								</span>
							)}
							{data?.packet_type?.send_to_ia && <span>
								<Button id="myButtonIncome" disabled={SentToIADisabled || data?.sentToIA} className={`btn btn-outline-success btn-los`} onClick={() => sentToIA()} color='link' >
									Send to Income Analyzer
								</Button>

								{outPutGeneratedAtIA || data?.fileVersions[data?.fileVersions.length - 1]?.outPutIAGeneratedAt ? <label className='send-date-label'>Sent to Income Analyzer:</label> : ''}
								{outPutGeneratedAtIA ?
									((outPutGeneratedAtIA && userDetail?.timezone) ?
										<><TimezoneClock timezone={userDetail.timezone} dateTime={outPutGeneratedAtIA} timeFormat={"MM/DD/YYYY h:mm A"} /></>
										:
										moment(outPutGeneratedAtIA).format(
											"MM/DD/YYYY"
										) + ' ' + moment(outPutGeneratedAtIA).format(
											"h:mm A"
										))
									:
									((data?.fileVersions[data?.fileVersions.length - 1]?.outPutIAGeneratedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={data?.fileVersions[data?.fileVersions.length - 1]?.outPutIAGeneratedAt} timeFormat={"MM/DD/YYYY h:mm A"} /></> :
										(data?.fileVersions[data?.fileVersions.length - 1]?.outPutIAGeneratedAt ? moment(data?.fileVersions[data?.fileVersions.length - 1]?.outPutIAGeneratedAt).format(
											"MM/DD/YYYY"
										) + ' ' + moment(data?.fileVersions[data?.fileVersions.length - 1]?.outPutIAGeneratedAt).format(
											"h:mm A"
										) : ''))}
							</span>}
							{data?.packet_type?.send_to_halcyon && <span>
								<Button disabled={SentToHalcyonDisabled || data?.sentToHalcyon} className={`btn btn-outline-success btn-los`} onClick={() => sentToHalcyon()} color='link' >
									Send To Halcyon/Pre-Authorization
								</Button>

								{outPutGeneratedAtHalcyon || data?.fileVersions[data?.fileVersions.length - 1]?.outPutHalcyonGeneratedAt ? <label className='send-date-label'>Sent To Halcyon/Pre-Authorization:</label> : ''}
								{outPutGeneratedAtHalcyon ?
									((outPutGeneratedAtHalcyon && userDetail?.timezone) ?
										<><TimezoneClock timezone={userDetail.timezone} dateTime={outPutGeneratedAtHalcyon} timeFormat={"MM/DD/YYYY h:mm A"} /></>
										:
										moment(outPutGeneratedAtHalcyon).format(
											"MM/DD/YYYY"
										) + ' ' + moment(outPutGeneratedAtHalcyon).format(
											"h:mm A"
										))
									:
									((data?.fileVersions[data?.fileVersions.length - 1]?.outPutHalcyonGeneratedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={data?.fileVersions[data?.fileVersions.length - 1]?.outPutHalcyonGeneratedAt} timeFormat={"MM/DD/YYYY h:mm A"} /></> :
										(data?.fileVersions[data?.fileVersions.length - 1]?.outPutHalcyonGeneratedAt ? moment(data?.fileVersions[data?.fileVersions.length - 1]?.outPutHalcyonGeneratedAt).format(
											"MM/DD/YYYY"
										) + ' ' + moment(data?.fileVersions[data?.fileVersions.length - 1]?.outPutHalcyonGeneratedAt).format(
											"h:mm A"
										) : ''))}
							</span>}
							<DocumentFormView fileData={fileData} pdf={generateOutputPdf} blobBuffer={blobBuffer} pageNumber={pageNumber} jsonMetaData={jsonMetaData} />
						</TabPane> : null}



						{activeTab == 4 ? <TabPane tabId="4" className='audit-log-list position-relative'>

							<DocumentLog />
							{/* <NoRecord /> */}
							{/* <LoaderUI FullWindow={false} inContainer /> */}
						</TabPane> : null}

						{currentDocument?.packet_type && <TabPane tabId="2" className='document-view-tabPane'>
							{/* {console.log(currentVersion, "chekign addXML")} */}
							{pdf && <DocumentFileView  /*setDisable={unAssignDisable}*/ setAddXmlTag={setAddXmlTag} saveversion={submitDocumentButton} _xmlTags={(val) => setXmlTags(val)} _originalXmlTags={(val) => setOriginalXmlTags(val)} xmlMeta={xmlMeta} setXmlMeta={setXmlMeta} pdf={pdf} pageNumber={pageNumber} jsonMetaData={jsonMetaData} _zoomOcr={zoomDoc} _zoomFlag={(val) => setDisabledZoomFlag(val)} _priorityFlag={priorityFlag} _refresh={_refresh} _zoomInOcr={(val) => _zoomInOcr(val)} _zoomOutOcr={(val) => _zoomOutOcr(val)} scale={defaultScaleDoc} activeLink={activeLink} disabledInputTagsText={disabledInputTagsText || fileData?.read_only /* || fileData?.assignedTo !== userDetail._id || unAssignDisable */ || deletedDisable} disabledZoomFlag={disabledZoomFlag} disabledZoomInButton={disabledZoomInButton} disabledZoomOutButton={disabledZoomOutButton} _activeEditTabs={activeEditTabs} _activeTab={activeTab} _currentVersion={currentVersion} latestVersion={latestVersion} idleScale={idleScale} unableToValidate={!data?.unableToValidate || unableToValidate} />}
						</TabPane>}
						{activeTab == 1 ?
							<TabPane tabId="1" className='ocr-tabPane' ref={ref}>
								<div className='ocr-view-wrapper d-flex flex-fill overflow-auto'>
									<div className='overflow-auto ocr-col left-col d-flex flex-column overflow-auto'>
										<div className="ocr-pdf-wrapper d-flex flex-column overflow-auto" ref={myRef}>
											<div className='sticky-container'>
												<div className="head text-end overflow-auto">
													<div className="inner flex-fill d-flex align-items-center justify-content-end">
														{/* <span>ABCD</span> */}
														<Nav tabs>
															<NavItem>
																<NavLink className={activeSubTab === "1" ? "active" : ""}
																	onClick={() => { toggleSubTab('1') }}
																	style={{ color: activeSubTab === "1" ? "#2b68fa" : "#596882" }}
																>Tag View</NavLink>
															</NavItem>
															<NavItem>
																<NavLink className={activeSubTab === "2" ? "active" : ""}
																	onClick={() => { toggleSubTab('2') }}
																	style={{ color: activeSubTab === "2" ? "#2b68fa" : "#596882" }}
																>Original Document View</NavLink>
															</NavItem>
														</Nav>
														<div className={`pdf-filter-btns d-inline-flex align-items-center justify-content-end${!loader ? " disable" : ""}`}>

															{isQCPerson && data?.quality_control ? <div className="btn-col ms-auto d-inline-flex align-items-center">
																<span style={{ margin: "0px 10px" }}>QC Review</span>
																{console.log('button active link -->', activeLink)}
																<Button className={`btn ${qaActiveLink !== 1 ? 'btn-outline-success' : 'btn-success'}`} onClick={() => qaStatus(1)} color='link' data-toggle="tooltip" data-placement="top" title={qaActiveLink == 1 ? "PASSED" : "PASS"}>
																	PASS
																</Button>
																<Button className={`btn ${qaActiveLink !== 2 ? 'btn-outline-danger' : 'btn-danger'}`} onClick={() => qaStatus(2)} color='link' data-toggle="tooltip" data-placement="top" title={qaActiveLink == 2 ? "FAILED" : "FAIL"}>
																	FAIL
																</Button>
															</div> : null}
														</div>
														{currentDocument?.packet_type && activeEditTabs === '1' && <div className={`pdf-filter-btns d-inline-flex align-items-center justify-content-end flex-fill${!loader ? " disable" : ""}`}>
															<div className="btn-col ms-auto d-inline-flex align-items-center">
																{fileData?.assignedToName ? <label style={{ marginRight: '5px' }}><span style={{ fontWeight: "500" }}>Assigned to</span> : {fileData?.assignedToName}</label> : null}
																<Button className={`btn ${activeLink !== 1 ? 'btn-outline-success' : 'btn-success'}`} onClick={() => unAssignDocument()} hidden={unAssignDisable || fileData.assignedTo !== userDetail._id} color='link' data-toggle="tooltip" data-placement="top" title="Unassign">
																	Unassign
																</Button>
																<Button className={`btn ${activeLink !== 1 ? 'btn-outline-success' : 'btn-success'}`} onClick={() => _showReview(1)} color='link' data-toggle="tooltip" data-placement="top" title="No Review Required">
																	No Review Required
																</Button>
																<Button className={`btn ${activeLink !== 2 ? 'btn-outline-danger' : 'btn-danger'}`} onClick={() => _showReview(2)} color='link' data-toggle="tooltip" data-placement="top" title="Review Requested">
																	Review Requested
																</Button>
															</div>
														</div>
														}

														{currentDocument?.packet_type && <div className={`control-btns d-inline-flex align-items-center${!loader ? " disable" : ""}`}>
															<PdfControls _refresh={_refresh} _zoomInOcr={(val) => _zoomInOcr(val)} _zoomOutOcr={(val) => _zoomOutOcr(val)} _activeEditTabs={activeEditTabs} activeLink={activeLink} disabledZoomFlag={disabledZoomFlag} disabledZoomInButton={disabledZoomInButton} disabledZoomOutButton={disabledZoomOutButton} />

															{/*<Button
														color="link"
														className={`upload-file-btn link`} onClick={downLoadCsv} title="Download CSV"
													><FontAwesomeIcon icon={faCloudDownload} /></Button> */}
															<Button color="link" className={`tagpanel-toggle-btn ${istagPanelVisible ? 'editor-col' : 'no-editor-col'}`} onClick={tagPanelHandler}>
																Show Tag/Text
															</Button>
														</div>}



														{!is_multi_loan ? <PdfPageDropdown handleVal={(val) => changePage(val)} val={selectedPage} pdfPagesCount={pdfPagesCount} /> : null}

													</div>
												</div>
												<div className="file-version-blc d-inline-flex align-items-center text-start" id='getWidth'>
													<div className="left-col">
														<a href="#" className='lbl'>
															{fileData?.folder?.loan_number}
														</a>
														{/*<a href="#" className='lbl'>
													{fileData?.folder?.name}
													<span>
														({fileData?.folder?.loan_number})
													</span>
												</a>*/}
														<span className="arrow-icon">
															&raquo;
														</span>
														<label className='des'>
															{fileData?.name}
														</label>
													</div>
													<div className="right-col ms-auto">
														<label>
															<span>
																Revision:
															</span>
															{fileData?.revision == 0 ? "Original" : fileData?.revision}
														</label>
														<label>
															<span>
																By:
															</span>
															{createdUser}
														</label>
														<label>
															<span>
																On:
															</span>
															{(updatedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail?.timezone} dateTime={updatedAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail?.timezone} dateTime={updatedAt} timeFormat={"h:mm a"} /></> : moment(updatedAt).format(
																"MMM DD,YYYY"
															) + ' at ' + moment(updatedAt).format(
																"h:mm a"
															)}
														</label>
													</div>
												</div>
											</div>

											{/*
												!loader && <LoaderUI message={false} FullWindow={false} inContainer={true} />
														*/}

											<TabContent activeTab={activeSubTab} style={{ height: "100%" }}>
												<TabPane tabId="1" className="main-tab-pane">
													<div id="ocrView" className={`inner flex-fill overflow-auto ${!loader ? "position-relative" : ""}`} ref={myRef}>
														{pdf && activeSubTab == "1" && <OcrView nextPage={(val) => changePage(val)} prevPage={(val) => changePage(val)} setVersionLoader={setVersionLoader} isPageChange={isPageChange} isRightClicked={isRightClicked} pdf={pdf} pageNumber={pageNumber} pdfPagesCount={pdfPagesCount} _editTag={editTag} _uniId={(val, flag) => { processClickId(val, flag) }} _editTabsVal={editTabsVal} _xmlTags={(val) => setXmlTags(val)} _xmlTagsOriginal={(val) => setXmlTagsOriginal(val)} _originalXmlTags={(val) => setOriginalXmlTags(val)} _activeEditTabs={activeEditTabs} _reloadOcr={reloadOcr} _zoomOcr={zoomOcr} scale={defaultScale} _fieldPriority={fieldPriority} _setLoader={(val) => setLoader(val)} _priorityFlag={priorityFlag} _zoomFlag={(val) => setDisabledZoomFlag(val)} activeEditTabsFlag={activeEditTabsFlag} jsonMetaData={jsonMetaData} xmlMeta={xmlMeta} versionFlag={versionFlag} _version={(val) => setVersionFlag(val)} _setScrollOnSelect={setsScrollHeight} _activeTab={activeTab} idleScale={idleScale} />}


														{/* Add more TabPane components for additional tabs if needed */}

														{!loader && <LoaderUI message={true} FullWindow={false} inContainer={true} />}
														{versionLoader && <LoaderUI message={false} FullWindow={false} inContainer={true} />}
													</div>
												</TabPane>
												<TabPane tabId="2" className="main-tab-pane" style={{ height: "100%" }}>
													{pdf && activeSubTab == "2" && <OriginalDocumentView blobBuffer={data?.pdf_url_buffer} data={data} fileType={data?.file_type} scale={defaultScale1} pdf={pdf} />}

												</TabPane>
											</TabContent>
										</div>
									</div>
								</div>
							</TabPane> : null}

					</TabContent>
					{/* <LoaderUI message FullWindow={false} inContainer={true} /> */}
				</div>
				{
					activeTab == 1 && rightSide === "C" ? <div id="doc-tab" className={`overflow-auto d-flex flex-column ocr-col right-col 
							${istagPanelVisible ? 'active' : ''} w3-container w3-center w3-animate-right`}>
						<DocumentTab changeInputValue={changeInputValue} checkboxId={checkboxId} editInputBoxId={editInputBoxId} editInputTagsId={editInputTagsId} saveversion={submitButton} disabledSubmitButton={disabledSubmitButton || fileData?.read_only  /* || fileData?.assignedTo !== userDetail._id || unAssignDisable */ || deletedDisable} acceptedItms={acceptedItms} checkText={checkText} fileVersions={fileVersions} xmlTags={xmlTags} _focus={uniId} outSide={outSide} _changeTab={_changeTabTags} _editXmlTags={(v) => setEditTag(v)} _editTagVal={(v) => { setEditTabsVal(v) }} _changesXmlTags={(v, inx, currentPage, changesViaVersion, tagId, item) => changesXmlTags(v, inx, currentPage, changesViaVersion, tagId, item)} _changesXmlText={(v, index, pos, id, item) => changesXmlText(v, index, pos, id, item)} _acceptXmlText={(v, index, pos, id) => acceptXmlText(v, index, pos, id)} _activeEditTabs={activeEditTabs} _fieldPriority={fieldPriority} loader={loader} noRecordFound={noRecordFound} _noRecordFound={(v) => setNoRecordFound(v)} disabledInputTagsText={disabledInputTagsText || fileData?.read_only /*|| unAssignDisable || fileData?.assignedTo !== userDetail._id*/ || deletedDisable} disabledButtonFlag={disabledZoomFlag} isTextInputEmpty={isTextInputEmpty} _OnCTextChange={(value, key, index, check) => OnCTextChange(value, key, index, check)} _OnCTagsChange={(e, key, index) => OnCTagsChange(e, key, index)} unableToValidate={!data?.unableToValidate || unableToValidate} />
					</div> : activeTab == 1 && rightSide === "V" ? <div className={`overflow-auto d-flex flex-column ocr-col right-col 
							${istagPanelVisible ? 'active' : ''} document-validation-col w3-container w3-center w3-animate-right`}>
						<div className="document-validation d-flex flex-column flex-fill overflow-auto">
							{!data?.unableToValidate || unableToValidate ? <>
								<div className="head d-flex align-items-center">
									{valiadationDetail && <Button color='link' className='validate-btn btn-outline-secondary ' disabled={disabledInputTagsText || fileData?.read_only  /* || fileData?.assignedTo !== userDetail._id || unAssignDisable */ || deletedDisable} onClick={() => validateData()}>
										Validate
									</Button>}
									{valiadationDetail && <Button color='secondary' className='save-btn' disabled={disabledInputTagsText || fileData?.read_only  /* || fileData?.assignedTo !== userDetail._id || unAssignDisable */ || deletedDisable} onClick={() => saveValidateData()}>
										Save
									</Button>}
									{!valiadationDetail && <Button color='secondary' className='save-btn' disabled={disabledInputTagsText || fileData?.read_only  /* || fileData?.assignedTo !== userDetail._id || unAssignDisable */ || deletedDisable} onClick={() => processValidateData()}>
										Process validate
									</Button>}
									{/*<Button color='secondary' className='save-btn' disabled={disabledInputTagsText} onClick={() => generateOutputData()}>
									Generate Output 
				                </Button>*/}
									<Button color='link' className='submit-btn p-0 ms-auto' onClick={closeRightSideBar}>
										<FontAwesomeIcon icon={faClose} />
									</Button>
								</div>
								<div className="head d-flex align-items-center">
									{valiadationDetail && <Button style={{ backgroundColor: "yellow" }} color='black' className='save-btn' disabled={disabledInputTagsText || fileData?.read_only || deletedDisable /* || !fileData?.output_blob_url || !fileData?.packet_type?.send_to_los || fileData?.is_verified ==  2 */} onClick={() => { triageDocument() }} >
										Triage
									</Button>}
									{valiadationDetail && <Button color='success' className='save-btn' disabled={disabledInputTagsText || fileData?.read_only || deletedDisable /* || !fileData?.output_blob_url || !fileData?.packet_type?.send_to_los || fileData?.is_verified ==  2 */} onClick={() => { markCompleted() }}>
										Mark Complete
									</Button>}
								</div>
								<div className="head d-flex align-items-center">
									{valiadationDetail && <Button color='danger' className='save-btn' disabled={disabledInputTagsText || fileData?.read_only  /* || fileData?.assignedTo !== userDetail._id || unAssignDisable */ || deletedDisable} onClick={() => { setIsUnableToValidateOpen(true); setDisabledUnableToDocumentFields(false) }}>
										Unable to Validate
									</Button>}
								</div>

							</>
								: <>
									<div className='validation-error-msg'>
										Validation unsuccessful.
									</div>

									<div className="head d-flex align-items-center">
										<Button style={{ color: 'white', background: 'gray', borderColor: 'gray' }} className='save-btn' disabled={disabledRevilidateButton || fileData?.read_only  /* || fileData?.assignedTo !== userDetail._id || unAssignDisable */ || deletedDisable} onClick={() => setUnableToValidate(true)}>
											RE-VALIDATE
										</Button>
										<Button color='link' className='submit-btn p-0 ms-auto' onClick={() => { setIsUnableToValidateOpen(true); setDisabledUnableToDocumentFields(true) }}>
											<FontAwesomeIcon icon={faEye} />
										</Button>
									</div>
								</>

							}
							<div className="inner overflow-auto">
								<DocumentAccordion disabledInputText={disabledInputTagsText || fileData?.read_only /* || fileData?.assignedTo !== userDetail._id || unAssignDisable */ || deletedDisable} valiadationData={valiadationDetail} setValiadationDetail={setValiadationDetail} _changesValidationText={(val, id, key, type, x, triggers) => changesValidationText(val, id, key, type, x, triggers)} _selectMoriOption={(val, index, previousValue, key) => selectMoriOption(val, index, previousValue, key)} _validate={() => validateData()} _textChange={vTextChange} _setTextChange={setVTextChange} _OnVTextChange={(value, key, check, id, errorCode, type, errorIndex, errorTitle) => OnVTextChange(value, key, check, id, errorCode, type, errorIndex, errorTitle)} invalidFields={invalidFields} setInvalidFields={setInvalidFields} unableToValidate={unableToValidate ? false : data?.unableToValidate ? true : false} xmlTags={(e) => { checkXmlTagPage(e); setTagValue(e) }} />
							</div >
						</div >
					</div > : ""

				}
				<UnableToValidateModal
					title={'Reason document cannot be validated'}
					disabled={disableUnableToUpdateButton || fileData?.read_only}
					disabledForm={disabledUnableToDocumentFields || fileData?.read_only}
					// operatorDetail={operatorDetail}
					showModel={isUnableToValidateOpen}
					// locations={locations}
					_toggle={() => setIsUnableToValidateOpen(false)}
					// addOperator={(params, callback) => _addOperator(params, callback)}
					// updateOperator={(params, id, callback) =>
					// 	_updateOperator(params, id, callback)
					// }
					// lodder={lodder}
					currentFile={currentDocument}
					valiadationData={valiadationData}
					_saveUnableToValidateJsonData={(data) => _saveUnableToValidateJsonData(data)}
				/>
			</div>
			<Modal isOpen={modalOpen}>
				<ModalHeader>{qaActiveLink == 1 ? "" : "Enter Reason for Failure"}
					<Button color='link' onClick={toggleModal}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="34"
							height="34"
							viewBox="0 0 34 34"
						>
							<g data-name="Group 651" transform="translate(-1535 -134)">
								<g
									fill="#fff"
									stroke="#000"
									strokeWidth="2"
									data-name="Ellipse 30"
									opacity="0.3"
									transform="translate(1535 134)"
								>
									<circle cx="17" cy="17" r="17" stroke="none"></circle>
									<circle cx="17" cy="17" r="16" fill="none"></circle>
								</g>
								<path
									d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
									data-name="Icon ionic-ios-close"
									opacity="0.3"
									transform="translate(1534.289 132.789)"
								></path>
							</g>
						</svg>
					</Button>
				</ModalHeader>
				<ModalBody>
					{qaActiveLink == 1 ? <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Does this Pass QC Review?</span> : <Input
						type="text"
						value={failureReason}
						onChange={handleInputChange}
						placeholder="Enter reason for failure"
						className='bold-placeholder'
					/>}
				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={handleSubmit}>
						Submit
					</Button>{' '}
					<Button color="secondary" onClick={toggleModal}>
						Cancel
					</Button>
				</ModalFooter>
			</Modal>
			<Modal isOpen={triageModalOpen && Boolean(fileData?.triageReason)} modalClassName="custom-modal">
				<ModalHeader>Reason for Triage
					<Button color='link' onClick={toggleTriageModal}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="34"
							height="34"
							viewBox="0 0 34 34"
						>
							<g data-name="Group 651" transform="translate(-1535 -134)">
								<g
									fill="#fff"
									stroke="#000"
									strokeWidth="2"
									data-name="Ellipse 30"
									opacity="0.3"
									transform="translate(1535 134)"
								>
									<circle cx="17" cy="17" r="17" stroke="none"></circle>
									<circle cx="17" cy="17" r="16" fill="none"></circle>
								</g>
								<path
									d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
									data-name="Icon ionic-ios-close"
									opacity="0.3"
									transform="translate(1534.289 132.789)"
								></path>
							</g>
						</svg>
					</Button>
				</ModalHeader>
				<ModalBody>
					<span>{fileData?.triageReason ? fileData?.triageReason : ""}</span>
				</ModalBody>
			</Modal>
		</>
	);
}

export default DocumentView;